export const ruResources = {
  translation: {
    common: {
      languages: {
        uz: "Узбекский (латиница)",
        "uz-cyrl": "Узбекский (кириллица)",
        ru: "Русский",
        en: "English",
      },
      languageShort: {
        uz: "UZ",
        "uz-cyrl": "UZ-K",
        ru: "RU",
        en: "EN",
      },
      actions: {
        goHome: "Вернуться на главную",
        tryAgain: "Попробовать снова",
        backToFiles: "Назад к XLS файлам",
        backToImports: "Назад к импортам",
        refresh: "Обновить",
        chooseFile: "Выбрать файл",
        changeFile: "Сменить файл",
        startImport: "Начать импорт",
        inspect: "Открыть",
        openItems: "Открыть позиции",
        login: "Войти",
        register: "Регистрация",
        forgotPassword: "Забыли пароль?",
        backToLogin: "Вернуться на страницу входа",
        restoreDefaults: "Сбросить по умолчанию",
        remove: "Удалить",
        more: "Другие действия",
        cancel: "Отмена",
        back: "Назад",
        clear: "Очистить",
      },
      copy: {
        copy: "Копировать",
        copyLabeled: "Копировать «{{label}}»",
        copied: "Скопировано в буфер обмена",
        copiedLabeled: "{{label}} скопировано",
      },
      rateLimit: {
        message: "Слишком много запросов. Подождите {{time}}.",
        seconds: "{{count}} сек",
        minutes_one: "{{count}} минуту",
        minutes_few: "{{count}} минуты",
        minutes_many: "{{count}} минут",
        minutes_other: "{{count}} минут",
      },
      account: {
        account: "Аккаунт",
        billing: "Оплата",
        notifications: "Уведомления",
        myOrganization: "Моя организация",
        logOut: "Выйти",
        authenticated: "авторизован",
        user: "пользователь",
        organization: "организация {{id}}",
      },
      states: {
        searching: "Поиск...",
        loading: "Загрузка...",
        noData: "Нет данных",
        latest: "Последний",
        none: "Нет",
        processing: "обработка",
        queued: "в очереди",
        finished: "Завершено",
      },
      currency: {
        som: "сум",
      },
      table: {
        firstPage: "Первая страница",
        prevPage: "Предыдущая страница",
        nextPage: "Следующая страница",
        lastPage: "Последняя страница",
      },
      routeError: {
        title: "Что-то пошло не так",
        description: "Не удалось загрузить страницу. Пожалуйста, попробуйте снова.",
        retry: "Попробовать снова",
      },
    },
    navigation: {
      new: "Новое",
      groups: {
        main: "Главное",
        organizations: "Организации",
        pricing: "Цены",
        authentication: "Аутентификация",
      },
      items: {
        medicines: "Лекарства",
        wholesaleOffers: "Оптовые предложения",
        priceAnalysis: "Анализ цен",
        priceTrends: "Динамика цен",
        organizations: "Организации",
        organizationRatings: "Рейтинг организаций",
        organizationImport: "Импорт",
        organizationEdit: "Моя организация",
        vendors: "Производители",
        certifiedMedicines: "Сертификаты",
        referentPrices: "Референтные цены",
        orders: "Заказы",
        cart: "Корзина",
        default: "Главная",
        crm: "CRM",
        analytics: "Аналитика",
        pharmacy: "Аптека",
        ecommerce: "E-Commerce",
        academy: "Академия",
        logistics: "Логистика",
        loginV1: "Вход v1",
        loginV2: "Вход v2",
        registerV1: "Регистрация v1",
        registerV2: "Регистрация v2",
      },
    },
    layout: {
      search: {
        button: "Поиск",
        placeholder: "Ищите дашборды, пользователей и другое…",
        empty: "Ничего не найдено.",
        quickCreate: "Быстро создать",
        inbox: "Входящие",
        shortcut: "Поиск",
        soon: "Скоро",
      },
      preferences: {
        title: "Настройки",
        description: "Настройте внешний вид дашборда.",
        storageNote:
          "Настройки по умолчанию используют cookies. В коде можно переключиться между cookies, localStorage или отключить сохранение.",
        themePreset: "Пресет темы",
        presetPlaceholder: "Пресет",
        fonts: "Шрифты",
        fontPlaceholder: "Выберите шрифт",
        themeMode: "Режим темы",
        pageLayout: "Макет страницы",
        navbarBehavior: "Поведение navbar",
        sidebarStyle: "Стиль sidebar",
        sidebarCollapseMode: "Режим сворачивания sidebar",
        modes: {
          light: "Светлая",
          dark: "Тёмная",
          system: "Системная",
        },
        layoutOptions: {
          centered: "По центру",
          fullWidth: "Во всю ширину",
        },
        navbarOptions: {
          sticky: "Закреплён",
          scroll: "С прокруткой",
        },
        sidebarOptions: {
          inset: "Inset",
          sidebar: "Sidebar",
          floating: "Плавающий",
        },
        collapseOptions: {
          icon: "Иконка",
          offcanvas: "Offcanvas",
        },
      },
      medicineSearch: {
        button: "Поиск лекарств",
        title: "Найти лекарство",
        recent: "Недавние поиски",
      },
      languageSelector: {
        placeholder: "Язык",
        ariaLabel: "Язык приложения",
      },
      themeSwitcher: {
        ariaLabel: "Текущая тема: {{theme}}. Нажмите, чтобы переключить тему",
      },
    },
    auth: {
      checkingSession: "Проверка сессии...",
      login: {
        title: "Войдите в аккаунт",
        description: "Введите свои данные для входа.",
        phone: "Номер телефона",
        password: "Пароль",
        submit: "Войти",
        submitting: "Вход...",
        success: "Успешный вход.",
        invalidPhone: "Телефон должен быть в формате 998XXXXXXXXX.",
        passwordRequired: "Пароль обязателен.",
        failed: "Сейчас не удалось войти.",
        modes: {
          password: "Пароль",
          otp: "Telegram",
          switchToPassword: "Войти по паролю",
          switchToOtp: "Войти через Telegram",
        },
        noAccount: "Нет аккаунта?",
        errors: {
          invalidCredentials: "Неверный телефон или пароль.",
          tooManyAttempts: "Слишком много попыток. Попробуйте через 15 минут.",
          userNotFound: "Этот номер не зарегистрирован. Сначала зарегистрируйтесь.",
          tooManyOtp: "Слишком много запросов. Повторите позже.",
          notTelegram: "У этого номера нет Telegram. Войдите по паролю.",
          sendFailed: "Не удалось отправить код. Повторите позже.",
          codeInvalid: "Неверный код. Попробуйте ещё раз.",
          codeExpired: "Срок действия кода истёк или попытки исчерпаны. Начните заново.",
          verifyFailed: "Не удалось подтвердить код. Повторите попытку.",
          network: "Проверьте подключение к интернету.",
          generic: "Непредвиденная ошибка. Повторите попытку.",
        },
        otp: {
          phaseATitle: "Войти через Telegram",
          phaseADescription: 'Введите номер — мы отправим код в чат "Verification Codes" в Telegram.',
          phaseBTitle: "Введите код",
          phaseBDescription: 'Код отправлен в чат "Verification Codes" в Telegram.',
          sendCode: "Отправить код",
          sending: "Отправка...",
          codeLabel: "Код подтверждения",
          verify: "Подтвердить",
          verifying: "Проверка...",
          resend: "Отправить код повторно",
          resendIn: "Повтор через {{time}}",
          otherPhone: "Другой номер",
          sentTo: "Отправлено на {{phone}}",
        },
      },
      register: {
        title: "Создайте аккаунт",
        description: "Введите свои данные для регистрации.",
        otpDescription: "Мы отправили 6-значный код подтверждения по SMS.",
        language: "Язык",
        languagePlaceholder: "Выберите язык",
        languageRequired: "Пожалуйста, выберите язык.",
        firstName: "Имя",
        lastName: "Фамилия",
        phone: "Номер телефона",
        password: "Пароль",
        passwordConfirm: "Подтвердите пароль",
        showPassword: "Показать пароль",
        hidePassword: "Скрыть пароль",
        submit: "Зарегистрироваться",
        submitting: "Отправка...",
        success: "Регистрация прошла успешно.",
        failed: "Сейчас не удалось зарегистрироваться.",
        alreadyHaveAccount: "Уже есть аккаунт?",
        firstNameRequired: "Введите имя.",
        firstNameMax: "Имя не должно превышать 100 символов.",
        lastNameRequired: "Введите фамилию.",
        lastNameMax: "Фамилия не должна превышать 100 символов.",
        invalidPhone: "Телефон должен быть в формате 998XXXXXXXXX.",
        passwordRequired: "Пароль обязателен.",
        passwordMin: "Пароль должен содержать не менее 8 символов.",
        passwordConfirmRequired: "Подтвердите пароль.",
        passwordsMismatch: "Пароли не совпадают.",
        organizationInn: "ИНН организации",
        organizationInnHint: "Введите 9-значный ИНН, чтобы автоматически заполнить данные организации.",
        organizationInnInvalid: "ИНН должен состоять из 9 цифр.",
        organizationInnLookupLoading: "Ищем организацию…",
        organizationInnLookupNotFound: "Организация по этому ИНН не найдена.",
        organizationInnLookupFailed: "Не удалось получить данные. Введите их вручную.",
        organizationName: "Название организации",
        organizationNameRequired: "Введите название организации.",
        organizationNameMax: "Название организации не должно превышать 255 символов.",
        organizationAddress: "Адрес",
        organizationAddressMax: "Адрес не должен превышать 500 символов.",
        organizationSection: "Организация",
        modeCreateTitle: "Создать организацию",
        modeCreateDescription: "Создайте свою аптеку или склад.",
        modeJoinTitle: "Присоединиться к существующей",
        modeJoinDescription: "Отправить запрос владельцу организации.",
        modeJoinHint: "После регистрации выберите организацию для отправки запроса.",
        errors: {
          alreadyRegistered: "Этот номер уже зарегистрирован.",
          loginLink: "Войти",
          tooManyRequests: "Слишком много запросов. Повторите позже.",
          sendFailed: "Не удалось отправить код. Повторите позже.",
          generic: "Непредвиденная ошибка. Повторите попытку.",
          network: "Проверьте подключение к интернету.",
          organizationFailed: "Аккаунт создан, но не удалось создать организацию. Вы можете создать её позже.",
        },
      },
      forgotPassword: {
        title: "Сброс пароля",
        description: "Введите номер телефона, подтвердите код и установите новый пароль.",
        otpDescription: "Мы отправили 6-значный код подтверждения по SMS.",
        phone: "Номер телефона",
        newPassword: "Новый пароль",
        passwordConfirm: "Подтвердите пароль",
        submit: "Отправить код",
        submitting: "Отправка...",
        resetSubmit: "Сменить пароль",
        success: "Пароль обновлён. Теперь можете войти с новым паролем.",
        invalidPhone: "Телефон должен быть в формате 998XXXXXXXXX.",
        passwordRequired: "Пароль обязателен.",
        passwordMin: "Пароль должен содержать не менее 8 символов.",
        passwordConfirmRequired: "Подтвердите пароль.",
        passwordsMismatch: "Пароли не совпадают.",
        errors: {
          userNotFound: "Этот номер не зарегистрирован.",
          tooManyRequests: "Слишком много запросов. Повторите позже.",
          sendFailed: "Не удалось отправить код. Повторите позже.",
          codeExpired: "Срок действия кода истёк или попытки исчерпаны. Начните заново.",
          codeInvalid: "Неверный код подтверждения. Попробуйте снова.",
          network: "Проверьте подключение к интернету.",
          generic: "Непредвиденная ошибка. Повторите попытку.",
        },
      },
    },
    landing: {
      nav: {
        platform: "Платформа",
        data: "Данные",
        activity: "Активность",
        login: "Войти",
        getStarted: "Начать",
      },
      hero: {
        badge: "Аналитика фармацевтического рынка Узбекистана",
        title1: "Знайте реальную цену",
        title2: "до покупки",
        subtitle:
          "PharmaLogic ежедневно собирает и анализирует цены на лекарства от оптовиков по всему Узбекистану — чтобы аптеки могли сравнивать предложения, отслеживать тренды и закупать выгоднее.",
        cta: "Открыть дашборд",
        ctaSecondary: "Как это работает",
        trustRegions: "Регионов охвачено",
        trustUpdates: "Обновление данных",
        trustFree: "Бесплатный доступ",
      },
      problem: {
        badge: "Проблема",
        title: "Как аптеки покупают лекарства сегодня",
        before: "Без PharmaLogic",
        after: "С PharmaLogic",
        pain1: "Каждое утро вручную проверять десятки прайс-листов поставщиков в Telegram",
        pain2: "Сравнивать цены по Excel-файлам без единого формата",
        pain3: "Упускать лучшие предложения из-за отсутствия единого обзора рынка",
        pain4: "Невозможно понять, выросла или упала цена за последние недели",
        gain1: "Все цены поставщиков собираются и систематизируются автоматически каждый день",
        gain2: "Один поиск для сравнения всех предложений от всех оптовиков мгновенно",
        gain3: "Тренды и история цен — чтобы понимать, подходящий ли сейчас момент для покупки",
        gain4: "Уведомления об акциях и истекающих предложениях, которые можно пропустить",
      },
      showcase: {
        badge: "Продукт",
        title: "Создан для отделов закупок аптек",
        subtitle:
          "Чистый дашборд для поиска лекарств, сравнения оптовых цен, отслеживания трендов и оформления заказов — всё в одном месте.",
      },
      howItWorks: {
        badge: "Как это работает",
        title: "От сырых прайс-листов к умным решениям",
        subtitle: "Мы делаем сложную работу — а вы фокусируетесь на главном: получить лучшие цены для вашей аптеки.",
        step1Title: "Собираем данные",
        step1Desc:
          "Каждый день наша система подтягивает прайс-листы из Telegram-каналов поставщиков и автоматически обрабатывает Excel-файлы.",
        step2Title: "Чистим и систематизируем",
        step2Desc:
          "Сырые данные сопоставляются с нашей базой лекарств, цены проверяются, аномалии помечаются, рассчитываются дневные агрегаты.",
        step3Title: "Вы принимаете лучшие решения",
        step3Desc:
          "Ищите любое лекарство, видите все предложения отсортированные по цене, проверяйте тренд и добавляйте в заказ — за секунды, не часы.",
      },
      coverage: {
        badge: "По всей стране",
        title: "Охватываем каждый уголок Узбекистана",
        subtitle:
          "Данные поступают из всех 13 регионов. Будь вы аптека в Ташкенте или Нукусе — вы видите одну полную картину рынка.",
        pharmacies: "Отслеживаемых аптек",
        wholesalers: "Оптовиков",
        regions: "Регионов",
        vendors: "Производителей",
      },
      stats: {
        badge: "Данные рынка",
        title1: "Рынок в цифрах",
        title2: "обновляется ежедневно",
        subtitle:
          "Мы отслеживаем каждое лекарство, оптовое предложение и изменение цены по всей стране — вот как выглядят данные прямо сейчас.",
        medicines: "Лекарств в базе",
        vendors: "Производителей",
        pharmacies: "Розничных аптек",
        wholesalers: "Одобренных оптовиков",
        offers: "Активных оптовых предложений",
        coverage: "Покрытие оптовых цен",
      },
      features: {
        badge: "Что решает PharmaLogic",
        title1: "Закупки для аптек",
        title2: "без догадок",
        priceCompare: "Сравнение цен",
        priceCompareDesc:
          "Смотрите оптовые цены от всех поставщиков рядом. Мгновенно находите лучшее предложение на каждое лекарство.",
        trends: "Отслеживание трендов",
        trendsDesc:
          "Ежедневные агрегаты цен показывают рост, падение или стабильность. Замечайте сезонные паттерны и аномалии.",
        coverage: "Вся страна",
        coverageDesc:
          "Данные из всех 13 регионов Узбекистана. Розничные аптеки, оптовые дистрибьюторы и производители — всё в одном месте.",
        realtime: "Ежедневное обновление",
        realtimeDesc:
          "Прайс-листы собираются из Telegram-каналов поставщиков и обрабатываются автоматически каждый день.",
        search: "Умный поиск",
        searchDesc: "Находите любое лекарство по торговому или международному названию, форме выпуска или дозировке.",
        wholesale: "Анализ предложений",
        wholesaleDesc:
          "Сравнивайте предложения с учётом условий оплаты, сроков годности и акций. Фильтруйте по региону или поставщику.",
        analytics: "Аналитика рынка",
        analyticsDesc: "KPI уровня дашборда: объём рынка, покрытие, активность поставщиков и многое другое.",
        orders: "Управление заказами",
        ordersDesc: "Формируйте заказы из лучших оптовых предложений, отслеживайте выполнение и управляйте закупками.",
      },
      activity: {
        badge: "Активность за 30 дней",
        title: "Активность рынка",
        subtitle:
          "Ежедневная оптовая активность по всем отслеживаемым поставщикам — предложения, активные поставщики и акции.",
        offers: "Оптовые предложения",
        suppliers: "Обновления поставщиков",
        wholesalers: "Активные оптовики",
        promos: "Акции",
        unavailableTitle: "Рыночные данные временно недоступны",
        unavailableDescription: "График активности появится здесь, когда аналитические данные снова станут доступны.",
      },
      cta: {
        title1: "Начните делать",
        title2: "выгодные закупки",
        subtitle: "Бесплатный доступ к ценам на лекарства, оптовым предложениям и аналитике рынка Узбекистана.",
        login: "Войти",
        register: "Создать аккаунт",
      },
      footer: {
        rights: "Все права защищены.",
        tagline: "Платформа аналитики фармацевтического рынка Узбекистана.",
        quickLinks: "Быстрые ссылки",
        contact: "Контакты",
        poweredBy: "Powered by",
        privacy: "Политика конфиденциальности",
        accountDeletion: "Удаление аккаунта",
      },
      privacy: {
        title: "Политика конфиденциальности",
        lastUpdated: "Последнее обновление: 27 апреля 2026 года",
        backHome: "Вернуться на главную",
        intro:
          "PharmaLogic («мы», «нас», «наш») уважает вашу конфиденциальность. Настоящая Политика конфиденциальности описывает, как мы собираем, используем и защищаем ваши персональные данные. Используя платформу, вы соглашаетесь с условиями данной политики.",
        s1Title: "1. Какие данные мы собираем",
        s1Body:
          "Данные аккаунта: номер телефона, имя, название организации и адрес электронной почты. Данные использования: история поиска, просмотренные лекарства, содержимое корзины и заказы. Данные устройства: тип браузера, IP-адрес и локально кэшированное состояние аккаунта/сессии. Данные оптовых поставщиков собираются из открытых Telegram-каналов и являются бизнес-информацией (не персональными данными).",
        s2Title: "2. Как мы используем данные",
        s2Body:
          "Для предоставления и улучшения наших аналитических услуг, аутентификации пользователей и защиты учётных записей, отправки уведомлений об изменениях цен, акциях и истечении сроков, ответов на запросы пользователей и соблюдения юридических обязательств.",
        s3Title: "3. Передача данных",
        s3Body:
          "Мы никогда не продаём ваши персональные данные. Мы можем передавать данные нашим сервис-партнёрам (например, хостинг-провайдерам и SMS-шлюзам для OTP). Мы можем раскрыть данные, если этого требует закон или законный запрос правоохранительных органов.",
        s4Title: "4. Cookie и локальное хранилище",
        s4Body:
          "Мы используем HttpOnly cookie для вашей сессии. localStorage браузера хранит настройки интерфейса и нечувствительное кэшированное состояние аккаунта. Мы не используем сторонние рекламные или трекинговые cookie.",
        s5Title: "5. Безопасность данных",
        s5Body:
          "Все данные передаются по зашифрованному каналу через HTTPS. Аутентификация выполняется с помощью защищённых cookie и ключей идемпотентности для операций записи. Мы регулярно проводим проверки безопасности и ограничиваем доступ к системам.",
        s6Title: "6. Ваши права",
        s6Body:
          "Вы имеете право получить доступ к своим данным, просматривать их и исправлять через настройки аккаунта. Вы можете в любое время удалить свой аккаунт и все связанные с ним данные. Вы также можете отозвать согласие на обработку данных.",
        s7Title: "7. Срок хранения данных",
        s7Body:
          "Данные аккаунта хранятся до тех пор, пока вы не запросите их удаление. Анонимные агрегированные аналитические данные могут сохраняться в обезличенной форме для улучшения платформы.",
        s8Title: "8. Конфиденциальность детей",
        s8Body:
          "PharmaLogic — это B2B-платформа для аптек и оптовых продавцов. Сервис не предназначен для лиц младше 18 лет, и мы сознательно не собираем данные от детей.",
        s9Title: "9. Изменения в политике",
        s9Body:
          "Мы можем периодически обновлять эту Политику конфиденциальности. Дата последней редакции указана выше. О существенных изменениях мы уведомим вас по электронной почте или через платформу. Продолжение использования сервиса после изменений означает согласие с обновлённой политикой.",
        s10Title: "10. Связь с нами",
        s10Body: "По вопросам конфиденциальности или запросам обращайтесь к нам:",
      },
      privacyMobile: {
        title: "Политика конфиденциальности",
        lastUpdated: "Последнее обновление: 29 мая 2026 г.",
        backHome: "На главную",
        intro:
          "Настоящая Политика конфиденциальности описывает, как мобильное приложение PharmaLogic («мы», «нас», «наш») собирает, использует и защищает вашу информацию. Устанавливая и используя приложение, вы соглашаетесь с этой политикой.",
        s1Title: "1. Какую информацию мы собираем",
        s1Body:
          "Данные учётной записи, которые вы указываете при регистрации: имя и фамилия, номер телефона и пароль. Номер телефона подтверждается одноразовым SMS-кодом (OTP). Данные об использовании: поисковые запросы по лекарствам, просмотренные лекарства, сохранённые избранные и закладки, содержимое корзины. Данные об устройстве: модель устройства, версия операционной системы, версия приложения, язык и токен push-уведомлений.",
        s2Title: "2. Данные о местоположении",
        s2Body:
          "С вашего разрешения приложение использует приблизительное или точное местоположение, чтобы находить ближайшие аптеки и показывать расстояние до них. Местоположение обрабатывается только во время использования карты и поиска и никогда не применяется для рекламы. Вы можете предоставить или отозвать доступ к местоположению в любой момент в настройках устройства; приложение остаётся работоспособным без него.",
        s3Title: "3. Как мы используем информацию",
        s3Body:
          "Чтобы показывать наличие лекарств и ближайшие аптеки, аутентифицировать вас и защищать вашу учётную запись, сохранять избранное, закладки и корзину, отправлять включённые вами уведомления, отвечать на ваши сообщения и запросы, а также улучшать приложение.",
        s4Title: "4. Push-уведомления",
        s4Body:
          "Если вы включите уведомления, мы регистрируем токен push-уведомлений устройства, чтобы отправлять вам актуальные сообщения. Push-уведомления доставляются через сервис Expo и системы уведомлений Apple и Google. Вы можете отключить уведомления в любой момент в настройках устройства.",
        s5Title: "5. Сообщения о проблемах с аптеками",
        s5Body:
          "Когда вы сообщаете о проблеме с аптекой или позицией, мы собираем выбранную причину, идентификаторы аптеки и лекарства, ваш необязательный комментарий и необязательный контактный номер телефона, чтобы мы могли связаться с вами. Эта информация используется только для проверки и исправления указанной записи.",
        s6Title: "6. Передача информации",
        s6Body:
          "Мы никогда не продаём ваши персональные данные. Мы можем передавать данные поставщикам услуг, действующим от нашего имени, таким как хостинг-провайдеры, SMS-шлюз для доставки OTP и сервис push-уведомлений. Мы можем раскрыть информацию, если этого требует закон или обоснованный запрос органов власти.",
        s7Title: "7. Сторонние картографические и навигационные сервисы",
        s7Body:
          "Приложение показывает встроенную карту на основе Google Maps. Когда вы выбираете построение маршрута или звонок в аптеку, приложение открывает выбранное вами внешнее приложение — например, Google Maps, Yandex Maps, Яндекс Навигатор, Yandex Go или 2GIS, либо телефонный набор. На эти приложения распространяются их собственные политики конфиденциальности.",
        s8Title: "8. Безопасность данных",
        s8Body:
          "Все данные передаются по зашифрованным соединениям HTTPS. Токены аутентификации хранятся в защищённом хранилище вашего устройства (iOS Keychain / Android Keystore). Мы ограничиваем внутренний доступ и регулярно проверяем наши системы.",
        s9Title: "9. Ваши права",
        s9Body:
          "Вы можете просматривать и исправлять данные своей учётной записи в приложении. Вы можете в любой момент удалить свою учётную запись и все связанные данные, а также отозвать разрешения, такие как доступ к местоположению и уведомлениям, в настройках устройства.",
        s10Title: "10. Хранение данных",
        s10Body:
          "Мы храним данные вашей учётной записи до тех пор, пока вы не запросите их удаление. Локально сохранённые данные, например историю поиска, можно очистить в самом приложении. Анонимная агрегированная статистика может храниться в обезличенной форме для улучшения приложения.",
        s11Title: "11. Конфиденциальность детей",
        s11Body:
          "Приложение предназначено для широкой аудитории, ищущей информацию об аптеках и лекарствах. Оно не предназначено для детей младше 13 лет, и мы сознательно не собираем их персональные данные.",
        s12Title: "12. Связь с нами",
        s12Body: "По вопросам конфиденциальности или запросам обращайтесь к нам:",
      },
      accountDeletion: {
        backHome: "На главную",
        title: "Удаление аккаунта",
        intro:
          "Вы можете запросить удаление вашего аккаунта и всех связанных с ним данных в мобильном приложении PharmaLogic на этой странице. Введите номер телефона — мы подтвердим его с помощью SMS-кода.",
        whatDeletedTitle: "Какие данные будут удалены",
        deletedItem1: "Данные профиля: имя, фамилия и номер телефона",
        deletedItem2: "История заказов и поисковых запросов",
        deletedItem3: "Сохранённые избранные и закладки",
        deletedItem4: "Настройки уведомлений и push-токены",
        retainedNote:
          "Некоторые записи, требуемые по закону (например, документы по транзакциям), могут храниться в обезличенном виде.",
        graceNote:
          "После подтверждения запроса аккаунт будет полностью удалён в течение 3 дней. В этот период вы можете отменить удаление.",
        phoneLabel: "Номер телефона",
        invalidPhone: "Введите корректный номер телефона",
        confirmLabel: "Я подтверждаю удаление моего аккаунта и всех моих данных",
        confirmRequired: "Подтвердите, чтобы продолжить",
        sendCode: "Отправить код",
        sending: "Отправка...",
        verifyTitle: "Код подтверждения",
        codeSentTo: "Код подтверждения отправлен на номер {{phone}}",
        verify: "Подтвердить",
        verifying: "Проверка...",
        changePhone: "Изменить номер",
        resend: "Отправить снова",
        resendIn: "Отправить снова ({{time}})",
        scheduledTitle: "Удаление запланировано",
        scheduledMessage: "Аккаунт {{phone}} будет полностью удалён {{date}}.",
        scheduledHint: "Если передумаете, вы можете отменить удаление до этой даты.",
        cancelButton: "Отменить удаление",
        cancelling: "Отмена...",
        cancelledTitle: "Удаление отменено",
        cancelledMessage: "Ваш аккаунт сохранён. Никакие данные не были удалены.",
      },
    },
    feedback: {
      pageNotFound: {
        title: "Страница не найдена.",
        description: "Страница, которую вы ищете, не найдена.",
      },
      dashboardComingSoon: {
        description: "Этот раздел появится в следующих обновлениях.",
      },
      pageInDevelopment: {
        description: "Эта страница находится в разработке и станет доступна в будущих обновлениях.",
      },
      unauthorized: {
        title: "Доступ запрещён",
        description:
          "У вас нет прав для просмотра запрошенного контента. Если вы считаете это ошибкой, свяжитесь с администратором сайта.",
      },
      serverError: {
        title: "Что-то пошло не так.",
        description: "Произошла непредвиденная ошибка. Попробуйте ещё раз или вернитесь на главную.",
      },
      externalLanding: "Скоро",
      tour: {
        next: "Далее",
        prev: "Назад",
        done: "Понятно",
        skip: "Пропустить",
        restart: "Запустить тур по странице заново",
        progress: "{{current}} / {{total}}",
        wholesaleOffers: {
          toolbar: {
            title: "Фильтрация и поиск",
            description: "Выбирайте препарат, организацию и регион. Фильтры мгновенно обновляют результаты.",
          },
          results: {
            title: "Оптовые предложения",
            description:
              "Все совпадающие предложения отображаются здесь. Кликните по строке, чтобы увидеть историю цен.",
          },
        },
        certificates: {
          search: {
            title: "Поиск сертификатов",
            description: "Введите название препарата, МНН или производителя. Достаточно нескольких символов.",
          },
          filters: {
            title: "Уточнить результаты",
            description: "Фильтруйте по году, стране, органу сертификации и сроку годности.",
          },
          results: {
            title: "Сертифицированные препараты",
            description: "Откройте строку, чтобы увидеть данные сертификата и остаток срока годности.",
          },
        },
        organizations: {
          list: {
            title: "Каталог организаций",
            description: "Просматривайте и ищите зарегистрированные организации. Выберите одну, чтобы открыть профиль.",
          },
          detail: {
            title: "Данные организации",
            description:
              "Профиль выбранной организации и её прайс-листы. Фильтруйте файлы по региону и условиям оплаты.",
          },
        },
        priceAnalysis: {
          search: {
            title: "Выберите препараты для сравнения",
            description:
              "Найдите и добавьте препараты, чтобы отслеживать их во времени. Они появятся в таблице сравнения ниже.",
          },
          compare: {
            title: "Таблица сравнения",
            description:
              "Все выбранные препараты с текущими ценами. Кликните по строке, чтобы выбрать активный препарат.",
          },
          trend: {
            title: "Динамика цен",
            description:
              "Наведите курсор на график, чтобы увидеть цены по датам. Переключайтесь между оптом, розницей и референтом.",
          },
        },
        priceTrends: {
          title: "Динамика цен",
          description: "Сравнивайте изменения цен на препараты за выбранный период.",
          window: "Период",
          windows: { "7": "7 дней", "30": "30 дней", "90": "90 дней" },
          coverage: "Период: {{start}} – {{end}}",
          coverageUnavailable: "Период недоступен",
          sections: {
            consistent: "Стабильные изменения цен",
            increases: "Наибольший рост цен",
            decreases: "Наибольшее снижение цен",
            volatile: "Самые волатильные цены",
          },
          table: {
            medicine: "Препарат",
            coverage: "Период",
            medianPrice: "Медианная цена",
            from: "было",
            metric: "Показатель",
          },
          direction: { rising: "Рост", falling: "Снижение" },
          empty: {
            title: "Нет препаратов для этого периода.",
            description: "Попробуйте другой период с достаточной историей цен.",
          },
          errorTitle: "Не удалось загрузить динамику цен",
          errorDescription: "Попробуйте ещё раз.",
          retry: "Повторить",
        },
      },
    },
    bugReport: {
      label: "Сообщить",
      open: "Сообщить об ошибке",
      tooltip: "Сообщить об ошибке или запросить функцию",
      title: "Сообщить об ошибке",
      description: "Отправьте детали проблемы нашей команде. Скриншот будет приложен, если он доступен.",
      submit: "Отправить",
      submitting: "Отправка...",
      successTitle: "Отчёт создан в Linear",
      successToast: "Отчёт {{issue}} создан",
      actions: {
        cancel: "Отмена",
        close: "Закрыть",
        remove: "Удалить",
      },
      fields: {
        description: "Описание",
        descriptionPlaceholder: "Что вы ожидали и что произошло вместо этого?",
      },
      screenshot: {
        label: "Скриншот",
        capture: "Сделать скриншот",
        capturing: "Создаём скриншот...",
        attach: "Прикрепить скриншот",
        retry: "Повторить скриншот",
        retake: "Переснять",
        error: "Не удалось сделать скриншот. Вы всё равно можете отправить отчёт.",
        tooLarge: "Скриншот должен быть не больше 4 МБ.",
        unsupportedFile: "Выберите файл изображения для скриншота.",
        previewAlt: "Предпросмотр скриншота отчёта",
        selectInstructions: "Выделите область курсором · Esc для отмены",
        selectCancel: "Отмена",
      },
      errors: {
        description: "Введите не менее 10 символов в описании.",
        submit: "Не удалось отправить отчёт об ошибке.",
      },
    },
    medicines: {
      noSelectionTitle: "Лекарство не выбрано",
      noSelectionDescription: "Найдите лекарство и выберите его из результатов, чтобы увидеть подробную информацию.",
      actions: {
        addGroup: "Добавить все",
        findAnalog: "Найти аналог",
        addToCart: "Корзина",
        removeFromCart: "Убрать из корзины",
        showInfo: "Показать информацию",
        showCertificate: "Показать связанный сертификат",
        goToOffer: "Перейти к предложению",
      },
      analogues: {
        title: "Аналоги",
        forMedicine: "Аналоги",
        errorTitle: "Не удалось загрузить аналоги",
        emptyTitle: "Аналоги не найдены",
        emptyDescription: "Нет совпадающих лекарств по коду ATC или международному наименованию.",
        noMatchesTitle: "Ничего не подходит под фильтр",
        noMatchesDescription: "Очистите фильтр по форме выпуска, чтобы увидеть все аналоги.",
        selectTitle: "Выберите аналог",
        selectDescription: "Нажмите на позицию в списке, чтобы увидеть подробности.",
        apply: "Применить",
      },
      dosageForms: {
        tablet: "таблетка",
        capsule: "капсула",
        syrup: "сироп",
        solution: "раствор",
        suspension: "суспензия",
        drops: "капли",
        injection: "инъекция",
        infusion: "инфузия",
        powder: "порошок",
        granule: "гранулы",
        ointment: "мазь",
        cream: "крем",
        gel: "гель",
        lotion: "лосьон",
        inhaler: "ингалятор",
        aerosol: "аэрозоль",
        spray: "спрей",
        suppository: "свеча",
        pessary: "пессарий",
        enema: "клизма",
        patch: "пластырь",
        paste: "паста",
        pastille: "пастилка",
      },
      units: {
        mg: "мг",
        g: "г",
        mcg: "мкг",
        kg: "кг",
        ml: "мл",
        l: "л",
        iu: "МЕ",
        percent: "%",
        pcs: "шт",
      },
      finder: {
        title: "Поиск лекарств",
        description:
          "Ищите лекарства по нестрогому совпадению, сравнивайте варианты по бренду и отслеживайте движение цен по периодам.",
        placeholder: "Найдите лекарство, например: парацетамол 500",
        minChars: "Введите минимум 3 символа",
        selected: "Выбрано",
        pickMedicine: "Выберите лекарство",
        startAvg: "Среднее в начале",
        endAvg: "Среднее в конце",
        change: "Изменение",
        range: "Диапазон",
        hints: {
          navigate: "перемещение",
          select: "выбрать",
          actions: "действия",
          close: "закрыть",
        },
      },
      recommendations: {
        optionLabel: "Рекомендовать лекарства по тексту пациента",
        optionDescription: "Подобрать совпадения в каталоге",
        backToSearch: "Назад к поиску",
        title: "Рекомендации из каталога лекарств",
        description: "Ранжированные совпадения, доказательства и предупреждения.",
        loading: "Загрузка ранжированных совпадений",
        recommendationCount_one: "{{count}} рекомендация",
        recommendationCount_few: "{{count}} рекомендации",
        recommendationCount_many: "{{count}} рекомендаций",
        recommendationCount_other: "{{count}} рекомендации",
        candidateCount_one: "Проверен {{count}} кандидат",
        candidateCount_few: "Проверено {{count}} кандидата",
        candidateCount_many: "Проверено {{count}} кандидатов",
        candidateCount_other: "Проверено {{count}} кандидата",
        emptyTitle: "Совпадений в каталоге не найдено.",
        emptyDescription_one: "Всего проверен {{count}} кандидат.",
        emptyDescription_few: "Всего проверено {{count}} кандидата.",
        emptyDescription_many: "Всего проверено {{count}} кандидатов.",
        emptyDescription_other: "Всего проверено {{count}} кандидата.",
        catalogMatch: "Совпадение из каталога",
        evidence: "Доказательства",
        safetyWarnings: "Предупреждения по безопасности",
        errors: {
          emptyQuery: "Введите текст пациента для сопоставления с каталогом.",
          queryTooLong: "Текст пациента должен быть не длиннее 1000 символов.",
          limit: "Лимит должен быть от 1 до 50.",
          age: "Возраст должен быть неотрицательным значением до 130.",
          load: "Не удалось загрузить рекомендации лекарств.",
        },
      },
      searchResults: {
        title: "Результаты поиска",
        description:
          "Варианты сгруппированы, чтобы было проще сравнивать форму, дозировку, упаковку и страну происхождения.",
        emptyTitle: "Совпадений не найдено",
        emptyDescription: "Попробуйте более общее название лекарства или уберите лишние детали о дозировке и упаковке.",
      },
      trend: {
        title: "Тренд цены",
        selectedTitle: "Тренд цены: {{name}}",
        description: "Выберите результат поиска, чтобы загрузить историю цен.",
        selectedDescription: "Данные тренда из /daily-prices?medicine_id={{id}}",
        noMedicineTitle: "Лекарство не выбрано",
        noMedicineDescription: "Выберите один из результатов, чтобы увидеть сводку и историю изменения цен.",
        refreshingTitle: "Тренд обновляется...",
        refreshingDescription: "Загружаются последние данные по ценам.",
        refreshingLabel: "Тренд обновляется…",
        emptyTitle: "Нет данных о цене за этот период",
        emptyDescription: "Лекарство выбрано, но backend не вернул точки тренда за выбранный период.",
        wholesale: "Опт",
        retail: "Розница",
        stockTurnover: "Оборачиваемость",
        latestWholesaleOffers: "Последние оптовые предложения",
        historicalLeaders: "Исторические лидеры: {{medicine}}",
        loadingLatestOffers: "Загрузка последних предложений...",
        noLatestWholesaleOffers: "Последние оптовые предложения не найдены.",
        offersBadgeCheapest: "Самое дешёвое",
        offersBadgeMostExpensive: "Самое дорогое",
        offersBadgePromo: "Акция",
        offersIssued: "Опубликовано {{date}}",
        offersExpires: "годен до {{date}}",
        offersOpenSource: "Открыть прайс-лист",
        noWholesaleHistory: "Нет истории оптовых цен.",
        noRetailHistory: "Нет истории розничных цен.",
        noHistory: "История недоступна.",
        turnoverRate: "Коэф. оборачиваемости",
        organizations: "организаций",
        median: "Медиана",
        min: "Мин",
        max: "Макс",
        movingAverage: "10д скользящая",
        wholesaleChartAria: "График оптового и розничного тренда",
        turnoverChartAria: "График оборачиваемости",
        periodSummary: "Загружено точек: {{points}}",
        showAll: "Показать все",
        comparingMedicines: "Сравнение {{count}} лекарств",
        enableAtLeastOneMetric: "Включите хотя бы одну метрику, чтобы увидеть данные.",
        referentWholesale: "Референт (опт)",
        referentRetail: "Референт (розница)",
      },
      referent: {
        sectionTitle: "Гос. реф. цены",
        wholesalePrice: "Опт",
        retailPrice: "Розница",
        referentPrice: "Референтная цена",
        registrationNumber: "Рег. №",
        updated: "Обновлено {{date}}",
        empty: "Государственная референтная цена для этого лекарства не найдена.",
      },
      badges: {
        singleVariant: "Один известный вариант",
        prescription: "По рецепту",
        otc: "Без рецепта",
        noPrice: "Нет цены",
        noAliases: "Нет альтернативных названий",
        offerCount_one: "{{count}} оптовое предложение",
        offerCount_few: "{{count}} оптовых предложения",
        offerCount_many: "{{count}} оптовых предложений",
        lowestPrice: "от {{price}} сўм",
        offerCount_other: "{{count}} оптовых предложений",
        rx: "Рецепт",
        inCart: "В корзине",
      },
      containerTypes: {
        ampoule: "Ампула",
        blister: "Блистер",
        bottle: "Флакон",
        box: "Коробка",
        canister: "Канистра",
        jar: "Банка",
        packet: "Пакет",
        sachet: "Саше",
        tube: "Туба",
        vial: "Виала",
      },
      productTypes: {
        cosmetic: "Косметическое средство",
        device: "Медицинское изделие",
        medicine: "Лекарство",
        supplement: "Добавка",
      },
      labels: {
        form: "Форма",
        strength: "Дозировка",
        volume: "Объём",
        dosageForm: "Форма выпуска",
        containerType: "Тип тары",
        pack: "Упаковка",
        country: "Страна",
        vendor: "Производитель",
        score: "Скор",
        id: "ID",
        variantCount_one: "{{count}} вариант",
        variantCount_few: "{{count}} варианта",
        variantCount_many: "{{count}} вариантов",
        variantCount_other: "{{count}} варианта",
        packPieces: "№{{count}}",
        averagePrice: "Средняя цена",
        minimumPrice: "Минимальная цена",
        maximumPrice: "Максимальная цена",
      },
      details: {
        title: "Детали",
        groups: {
          summary: "Сводка",
          use: "Применение",
          safety: "Безопасность",
          pharmacology: "Фармакология",
          storage: "Хранение",
        },
        displayName: "Название в источнике",
        tradeNameLatin: "Латинское торговое название",
        dosageFormText: "Форма выпуска",
        activeSubstance: "Действующее вещество",
        clinicalPharmacologicalGroup: "Клинико-фармакологическая группа",
        pharmacotherapeuticGroup: "Фармакотерапевтическая группа",
        manufacturerName: "Производитель",
        contactOrganizationName: "Организация для обращений",
        icd10Codes: "Коды МКБ-10",
        usedFor: "Для чего применяется",
        indications: "Показания",
        contraindications: "Противопоказания",
        dosageInstructions: "Способ применения",
        sideEffects: "Побочные эффекты",
        pregnancyLactation: "Беременность и лактация",
        hepaticImpairment: "Нарушение функции печени",
        renalImpairment: "Нарушение функции почек",
        pediatricUse: "Применение у детей",
        geriatricUse: "Применение у пожилых",
        specialInstructions: "Особые указания",
        overdose: "Передозировка",
        composition: "Состав",
        pharmacologicalAction: "Фармакологическое действие",
        pharmacokinetics: "Фармакокинетика",
        storageConditions: "Условия хранения",
        pharmacyReleaseTerms: "Условия отпуска из аптек",
        drugInteractions: "Лекарственное взаимодействие",
        vendor: "Производитель",
        shelfLifeYear_one: "{{count}} год",
        shelfLifeYear_few: "{{count}} года",
        shelfLifeYear_many: "{{count}} лет",
        shelfLifeYear_other: "{{count}} лет",
        shelfLifeMonth_one: "{{count}} месяц",
        shelfLifeMonth_few: "{{count}} месяца",
        shelfLifeMonth_many: "{{count}} месяцев",
        shelfLifeMonth_other: "{{count}} месяцев",
        shelfLife: "Срок",
        icdCodes: "Коды МКБ",
        variations: "Варианты",
        variationsOther: "Другое",
        certificates: "Сертификаты",
        rxBadge: "Рецепт",
        atcLabel: "ATC {{code}}",
        source: "Источник",
        sourceNamed: "Источник {{source}}",
        openSource: "Открыть источник",
        openSourceNamed: "Открыть источник {{source}}",
        sourceUpdated: "обновлено {{date}}",
        vitalEssential: "Жизненно необходимый и важнейший препарат",
      },
    },
    account: {
      edit: {
        title: "Редактировать профиль",
        description: "Обновите имя, которое отображается в приложении.",
        firstName: "Имя",
        lastName: "Фамилия",
        phone: "Номер телефона",
        phoneHelp: "Чтобы изменить номер, обратитесь в поддержку.",
        submit: "Сохранить изменения",
        submitting: "Сохранение…",
        success: "Профиль обновлён.",
        errors: {
          firstNameRequired: "Введите имя.",
          firstNameMax: "Имя слишком длинное.",
          lastNameRequired: "Введите фамилию.",
          lastNameMax: "Фамилия слишком длинная.",
          generic: "Не удалось обновить профиль. Попробуйте ещё раз.",
        },
      },
      password: {
        title: "Изменить пароль",
        description: "Установите новый пароль для своей учётной записи.",
        currentPassword: "Текущий пароль",
        newPassword: "Новый пароль",
        confirmPassword: "Подтвердите новый пароль",
        submit: "Обновить пароль",
        submitting: "Обновление…",
        success: "Пароль обновлён.",
        modal: {
          title: "Изменение пароля",
          description: "Введите текущий пароль и выберите новый.",
          save: "Обновить пароль",
          saving: "Обновление…",
        },
        errors: {
          currentRequired: "Введите текущий пароль.",
          currentInvalid: "Неверный текущий пароль.",
          passwordRequired: "Введите новый пароль.",
          passwordMin: "Пароль должен содержать минимум 8 символов.",
          passwordMax: "Пароль слишком длинный.",
          confirmRequired: "Подтвердите новый пароль.",
          mismatch: "Пароли не совпадают.",
          generic: "Не удалось изменить пароль. Попробуйте ещё раз.",
        },
      },
      mockBadge: {
        badge: "Демо-данные",
        title: "Эта страница в разработке",
        description:
          "Все данные на этой странице демонстрационные и не отражают реальное состояние аккаунта. Полная функциональность появится в следующих обновлениях.",
      },
      overview: {
        title: "Аккаунт",
        description: "Личная информация и настройки аккаунта.",
        profile: {
          title: "Личная информация",
          fullName: "Полное имя",
          phone: "Номер телефона",
          email: "Электронная почта",
          role: "Должность",
          organization: "Организация",
          memberSince: "Дата регистрации",
          notSet: "Не указано",
          edit: "Редактировать профиль",
        },
        security: {
          title: "Безопасность",
          description: "Настройки входа и безопасности аккаунта.",
          twoFactor: "Двухфакторная аутентификация",
          twoFactorOff: "Выключено",
          twoFactorOn: "Включено",
          changePassword: "Сменить пароль",
        },
        sessions: {
          title: "Активные сессии",
          description: "Устройства, на которых вы сейчас в системе.",
          current: "Текущее устройство",
          signOut: "Выйти",
          devices: {
            mac: "MacBook Pro · Chrome",
            windows: "Windows ПК · Edge",
            ios: "iPhone · Safari",
          },
          locations: {
            tashkent: "Ташкент, Узбекистан",
            samarkand: "Самарканд, Узбекистан",
          },
          lastSeen: "активно {{when}}",
          minutesAgo: "{{count}} мин назад",
          hoursAgo: "{{count}} ч назад",
          daysAgo: "{{count}} д назад",
        },
      },
      billing: {
        title: "Оплата",
        description: "Тарифный план, способы оплаты и счета.",
        plan: {
          title: "Текущий тариф",
          name: "Pro",
          priceMonthly: "{{amount}} / месяц",
          renewsOn: "Обновится {{date}}",
          manage: "Управление тарифом",
          features: {
            unlimited: "Неограниченная загрузка прайс-листов",
            priority: "Приоритетная поддержка",
            analytics: "Расширенная аналитика",
          },
        },
        paymentMethod: {
          title: "Способ оплаты",
          primary: "Основная карта",
          expires: "Действует до {{date}}",
          addNew: "Добавить новую карту",
        },
        invoices: {
          title: "История платежей",
          empty: "Пока нет ни одного счёта.",
          columns: {
            number: "Номер",
            date: "Дата",
            amount: "Сумма",
            status: "Статус",
            action: "Действие",
          },
          status: {
            paid: "Оплачено",
            pending: "В ожидании",
            failed: "Не прошло",
          },
          download: "Скачать",
        },
      },
      notificationsPage: {
        title: "Уведомления",
        description: "Выберите, какие уведомления получать, и просмотрите последние события.",
        preferences: {
          title: "Настройки уведомлений",
          description: "Выберите, по каким каналам приходят уведомления.",
          channels: {
            email: "Email",
            push: "Push",
            sms: "SMS",
          },
          categories: {
            orders: "Обновления заказов",
            priceChanges: "Изменения цен",
            system: "Системные сообщения",
            marketing: "Маркетинг и акции",
          },
        },
        feed: {
          title: "Последние уведомления",
          empty: "Новых уведомлений нет.",
          markAllRead: "Отметить все прочитанными",
          unread: "Новое",
          items: {
            orderConfirmed: {
              title: "Заказ подтверждён",
              body: "Заказ №1284 принят поставщиком.",
              when: "10 мин назад",
            },
            priceDrop: {
              title: "Цена снизилась",
              body: "Цена на отслеживаемый «Парацетамол 500мг» снизилась на 12%.",
              when: "1 ч назад",
            },
            stockAlert: {
              title: "Мало остатков",
              body: "«Аспирин 100мг» заканчивается на вашем складе.",
              when: "3 ч назад",
            },
            invoiceReady: {
              title: "Новый счёт",
              body: "Счёт за апрель готов к просмотру.",
              when: "Вчера",
            },
            systemUpdate: {
              title: "Обновление системы",
              body: "Платформа обновлена, добавлены новые функции.",
              when: "2 д назад",
            },
          },
        },
      },
    },
    organizations: {
      create: {
        title: "Создайте свою организацию",
        description:
          "Перед тем как использовать дашборд, вам нужно создать организацию. Вы будете назначены её владельцем.",
        name: "Название организации",
        address: "Адрес",
        city: "Город",
        region: "Регион",
        regionPlaceholder: "Выберите регион",
        district: "Район",
        type: "Тип организации",
        typePlaceholder: "Выберите тип",
        logo: "Логотип",
        logoUpload: "Загрузить изображение",
        phones: "Телефоны",
        addPhone: "Добавить телефон",
        removePhone: "Удалить телефон",
        submit: "Создать организацию",
        submitting: "Создание...",
        success: "Организация успешно создана.",
        errors: {
          nameRequired: "Введите название организации.",
          nameMax: "Название не должно превышать 255 символов.",
          addressMax: "Адрес не должен превышать 500 символов.",
          cityMax: "Город не должен превышать 255 символов.",
          districtMax: "Район не должен превышать 255 символов.",
          regionInvalid: "Выберите корректный регион.",
          typeRequired: "Укажите тип организации.",
          typeInvalid: "Выберите корректный тип.",
          phoneInvalid: "Телефон должен соответствовать 998XXXXXXXXX.",
          phonesMax: "Можно добавить не более 20 телефонов.",
          alreadyHasOrganization: "Вы уже состоите в организации.",
          generic: "Не удалось создать организацию. Попробуйте ещё раз.",
        },
      },
      types: {
        retail: "Розница",
        wholesale: "Опт",
      },
      regions: {
        andijon: "Андижан",
        buxoro: "Бухара",
        fargona: "Фергана",
        jizzax: "Джизак",
        qashqadaryo: "Кашкадарья",
        qoraqalpogiston: "Каракалпакстан",
        namangan: "Наманган",
        navoiy: "Навои",
        samarqand: "Самарканд",
        sirdaryo: "Сырдарья",
        surxondaryo: "Сурхандарья",
        toshkent: "Ташкент",
        toshkent_viloyati: "Ташкентская область",
        xorazm: "Хорезм",
      },
      edit: {
        title: "Редактирование организации",
        description: "Обновите данные вашей организации.",
        submit: "Сохранить изменения",
        submitting: "Сохранение...",
        success: "Организация успешно обновлена.",
        loadError: "Не удалось загрузить организацию.",
        noOrganization: "Вы ещё не состоите в организации.",
        sections: {
          brandTitle: "Бренд",
          brandDescription: "Логотип и название, которые видят партнёры при взаимодействии с организацией.",
          locationTitle: "Местоположение",
          locationDescription: "Где расположена организация?",
          contactTitle: "Телефоны",
          contactDescription: "По этим номерам с вами будут связываться покупатели.",
        },
        errors: {
          generic: "Не удалось обновить организацию. Попробуйте ещё раз.",
        },
      },
      list: {
        searchPlaceholder: "Поиск организаций",
        loadErrorTitle: "Не удалось загрузить организации",
        emptyTitle: "Организации не найдены",
        emptyDescription: "Попробуйте другой поисковый запрос.",
        addressMissing: "Адрес не указан",
        latestPrice: "прайс",
        typeFilter: {
          all: "Все",
        },
      },
      info: {
        chooseOrganization: "Выберите организацию",
        detailsHint: "Выберите организацию слева, чтобы посмотреть контакты и ссылки Telegram.",
        noPhones: "Номера телефонов отсутствуют.",
        lastFile: "Последний файл:",
        noGroups: "Подключённых Telegram-групп нет.",
        notAvailable: "Недоступно",
        groupFallback: "Группа {{id}}",
        approved: "Одобрено {{date}}",
      },
      telegram: {
        title: "Telegram-каналы",
        description: "Статус последней загрузки по каждому подключённому Telegram-каналу.",
        empty: "Telegram-каналы пока не подключены.",
        lastCrawl: "Последняя загрузка",
        lastFile: "Последний файл",
        notCrawled: "Ещё не загружался",
        noFile: "Файлов пока нет",
        disabled: "Отключён",
      },
      workspace: {
        title: "Рабочая область",
        filesDescription: "Просматривайте загруженные прайс-листы и открывайте их по одному.",
        importDescription: "Поставьте в очередь импорт нового workbook для выбранной организации.",
        tabs: {
          files: "Прайс-листы",
          import: "Импорт",
        },
      },
      files: {
        loadErrorTitle: "Не удалось загрузить данные организации",
        emptyTitle: "Файлы прайс-листа не найдены",
        emptyDescription: "У этой организации пока нет видимых XLS прайс-листов.",
        issueDateMissing: "Дата выпуска недоступна",
        status: {
          processing: "Обработка",
          completed: "Готово",
          failed: "Ошибка",
        },
        rows: "{{count}} строк",
        sheet: "Лист: {{value}}",
        payment: "Оплата: {{value}}%",
        paginationSummary: "Показано {{from}}–{{to}} из {{total}}",
        region: "Регион",
        allRegions: "Все регионы",
        regions: {
          andijon: "Андижон",
          bukhara: "Бухара",
          fergana: "Фергана",
          jizzakh: "Жиззах",
          karakalpakstan: "Каракалпакстан",
          namangan: "Наманган",
          navoiy: "Навои",
          qashqadaryo: "Кашкадарья",
          samarqand: "Самарканд",
          sirdaryo: "Сирдарья",
          surxondaryo: "Сурхандарья",
          tashkent: "Ташкент",
          xorazm: "Хорезм",
        },
      },
      indexedItems: {
        title: "Индексированные позиции прайс-листа",
        description: "Распарсенные позиции, которые backend вернул для выбранного файла.",
        filterPlaceholder: "Фильтр по всем колонкам",
        clickRow: "Нажмите на строку, чтобы открыть детали",
        loadErrorTitle: "Не удалось загрузить позиции прайс-листа",
        noFileTitle: "Файл не выбран",
        noFileDescription: "Выберите файл прайс-листа, чтобы посмотреть индексированные позиции.",
        noItemsTitle: "Индексированные позиции не найдены",
        noItemsDescription: "Для выбранного файла ещё нет распарсенных позиций.",
        fileDescription: "{{fileName}}",
        rowCount: "{{count}} строк",
        downloadXls: "XLS",
        downloadXlsx: "XLSX",
      },
      medicineSheet: {
        title: "Детали лекарства",
        description: "Просматривайте атрибуты лекарства, ценовой контекст и изменение цены по индексированной строке.",
        loadErrorTitle: "Не удалось загрузить детали лекарства",
        missingIdTitle: "Medicine ID отсутствует",
        missingIdDescription: "У этой индексированной строки нет связанной записи лекарства.",
        currentRowPrice: "Цена текущей строки",
        indexedRow: "Индексированная строка",
        trackedSamples: "Отслеживаемые образцы",
        periodDetail: "Период: {{period}}",
        priceChange: "Изменение цены",
        vsPeriodStart: "{{value}}% относительно начала периода",
        notEnoughHistory: "Пока недостаточно истории",
        priceMovement: "Движение цены",
        priceMovementDescription: "Ежедневные средние, минимальные и максимальные цены для выбранного лекарства.",
        periodPlaceholder: "Период",
        noHistoryTitle: "История цен недоступна",
        noHistoryDescription: "У этого лекарства недостаточно отслеживаемых данных по ценам за выбранный период.",
        profileTitle: "Профиль лекарства",
        profileDescription: "Основные атрибуты из каталога лекарств и выбранной индексированной строки.",
        indexedContextTitle: "Контекст индексированной строки",
        indexedContextDescription: "Исходные данные из выбранной строки прайс-листа.",
        trendStatus: "Статус тренда",
        labels: {
          name: "Название",
          internationalName: "Международное название",
          dosageForm: "Форма",
          strength: "Дозировка",
          volume: "Объём",
          pack: "Упаковка",
          packageQuantity: "Количество в упаковке",
          atcCode: "ATC код",
          vendorId: "ID производителя",
          prescription: "Рецепт",
          listedPrice: "Цена в каталоге",
          minMaxPrice: "Мин / Макс цена",
          priceListFileId: "ID файла прайс-листа",
          medicineId: "ID лекарства",
          rawName: "Исходное название",
          vendor: "Производитель",
          expiryDate: "Срок",
          issueDate: "Дата выпуска",
          crawledAt: "Время сбора",
          required: "Требуется",
          notRequired: "Не требуется",
        },
      },
      import: {
        importType: "Тип импорта",
        dragAndDrop: "или перетащите сюда",
        importFile: "Импорт файла",
        priceList: "Прайс-лист",
        orderList: "Список заказов",
        noWorkbook: "Workbook не выбран",
        readyToImport: "Этот workbook готов к импорту.",
        invalidFileType: "Выберите файл .xlsx, .xls или .csv.",
        supportedFormats: "Поддерживаемые форматы: .xlsx, .xls, .csv",
        capacityHint: "{{stored}}/{{storageLimit}} файлов сохранено · {{active}}/{{concurrentLimit}} в обработке",
        concurrentLimitReached:
          "Одновременно можно импортировать только {{limit}} файла. Дождитесь завершения текущих импортов.",
        storageLimitReached:
          "Достигнут лимит хранилища: организация может хранить не более {{limit}} импортированных файлов. Удалите один из файлов перед загрузкой нового.",
        queueing: "Импорт ставится в очередь...",
        signInRequired: "Войдите в систему, чтобы импортировать workbook файлы.",
        noOrganizationLinked: "Ваш аккаунт пока не привязан к организации.",
        selectOrganization: "Перед импортом выберите организацию.",
        switchOrganization: "Переключитесь на свою организацию, чтобы импортировать файлы своим аккаунтом.",
        queuedNotice: "{{fileName}} поставлен в очередь на импорт.",
        queuedNoticeFallback: "Импорт поставлен в очередь.",
        queueTitle: "Очередь импорта",
        queueDescriptionActive: "Задания workbook в очереди и обработке для вашего аккаунта.",
        queueDescriptionIdle: "Сейчас нет выполняемых заданий.",
        waitingToStart: "Ожидает запуска",
        inProgress: "Импорт выполняется",
        loadingJobs: "Загрузка заданий импорта...",
        noActiveTitle: "Активных импортов нет",
        noActiveDescription: "Запустите импорт Excel или CSV, чтобы видеть прогресс очереди здесь.",
        jobLabel: "Задача {{id}}",
        sheetsProgress: "{{completed}}/{{total}} листов",
        importedSheetsTitle: "Импортированные листы",
        importedSheetsDescription:
          "Ранее импортированные workbook-файлы. Нажмите на строку, чтобы просмотреть содержимое.",
        noImportedSheetsTitle: "Импортированных листов пока нет",
        noImportedSheetsDescription: "Импортируйте Excel или CSV файл, чтобы увидеть его здесь.",
        statusCompleted: "Готово",
        statusFailed: "Ошибка",
        deleteAction: "Удалить лист",
        deleteCancel: "Отмена",
        deleteConfirmAction: "Удалить",
        deleteConfirmTitle: "Удалить импортированный лист?",
        deleteConfirmDescription: "Это навсегда удалит {{name}} и импортированные строки.",
        deleteSuccess: "Импортированный лист удалён",
        deleteError: "Не удалось удалить импортированный лист",
        listColumns: {
          file: "Файл",
          rows: "Строк",
          imported: "Импортирован",
          status: "Статус",
        },
        fileLabel: "Имя файла",
        sheetDetailTitle: "Содержимое листа",
        sheetDetailDescription: "Строки, импортированные из этого workbook.",
        loadErrorTitle: "Не удалось загрузить содержимое листа",
        loadErrorDescription: "При загрузке данных листа произошла ошибка. Повторите попытку чуть позже.",
        sheetRowsSearchPlaceholder: "Фильтр по названию, ID, цене или исходным значениям",
        sheetRowsEmpty: "Нет строк, соответствующих фильтрам.",
        sheetRowsCount: "Показано {{from}}-{{to}} из {{total}}",
        rows: "строк",
        priceEdit: {
          success: "Цена обновлена",
          error: "Не удалось обновить цену",
          placeholder: "Цена в сумах",
          ariaLabel: "Изменить цену",
        },
        summary: {
          matched: "найдено",
          notFound: "не найдено",
        },
        columns: {
          name: "Название",
          price: "Цена",
          referentWholesalePrice: "Реф. опт",
          vendorName: "Производитель",
          rowIndex: "Индекс строки",
          code: "Код",
          expiryDate: "Срок",
          markup: "Наценка",
          vat: "НДС",
          priceNoVat: "Цена без НДС",
        },
        pricing: {
          column: "Реком. цена",
          targetMargin: "Целевая маржа",
          payment: "Оплата",
          termAdjustment: "Корр. срока",
          region: "Регион",
          action: "Рекомендовать цены",
          selected: "Выбрано: {{count}}",
          costPrice: "Себестоимость",
          missingCost: "Укажите положительную себестоимость для каждой выбранной строки.",
          infeasible: "Невозможно",
          selectRow: "Выберите строку для рекомендации цены",
        },
      },
      table: {
        columns: {
          rawName: "Исходное название",
          vendor: "Производитель",
          packageQuantity: "Кол-во в упаковке",
          expiry: "Срок",
          issueDate: "Дата выпуска",
          crawledAt: "Время сбора",
          price: "Цена",
        },
      },
      priceHover: {
        unknownMedicine: "Препарат",
        missingMedicineId: "К этой строке не привязан препарат (medicine_id).",
        noLiveOffers: "Нет актуальных оптовых предложений по препарату с ID {{medicineId}}.",
        noChartData: "Данных для графика нет.",
        daysWindow: "{{count}} дн.",
        vsMedian: "относительно медианы",
        recommended: "Рекомендуемая",
        referentWholesale: "Референт (опт)",
        referentRetail: "Референт (розница)",
        offersCount: "Опт. предложения",
        vsCheapest: "относительно минимума",
        cheaperOffers: "ДЕШЕВЛЕ",
        noCheaper: "Нет более дешёвых предложений",
        expensiveOffers: "ДОРОЖЕ",
        noExpensive: "Нет более дорогих предложений",
        expiryError: "Не удалось загрузить историю срока годности.",
        expiryEmpty: "История срока годности отсутствует.",
        expiryTurnover: "Скорость продаж",
        expiryOrgsLabel: "орг.",
        orgFallback: "Орг. {{id}}",
        tabs: {
          wholesale: "Опт",
          retail: "Розница",
          expiry: "Срок",
        },
        series: {
          median: "Медиана",
          min: "Мин",
          max: "Макс",
          avg: "10к СС",
          turnoverRate: "Скорость продаж",
          offerCount: "Кол-во предложений",
        },
      },
      ratings: {
        title: "Рейтинг организаций",
        description:
          "Оптовые поставщики, ранжированные по конкурентоспособности цен, ассортименту, активности и акциям за последние 90 дней.",
        allRegions: "Все регионы",
        count: "{{count}} организаций",
        errorTitle: "Не удалось загрузить рейтинг",
        emptyTitle: "Нет организаций",
        emptyDescription: "Ни одна оптовая организация не соответствует текущим фильтрам.",
        sortOptions: {
          overall: "Общий балл",
          cheapest_pct: "Лучшие цены",
          variety: "Широкий ассортимент",
          medicines: "Больше эксклюзивных препаратов",
          promotion_pct: "Больше акций",
          freshness: "Наиболее активные",
        },
        paymentOptions: {
          p100: "Оплата 100%",
          p50: "Оплата 50%",
          p30: "Оплата 30%",
        },
        scoreLabels: {
          price: "Цена",
          variety: "Ассортимент",
          medicines: "Эксклюзив",
          freshness: "Активность",
          promotions: "Акции",
        },
        metrics: {
          medicines: "{{count}} препаратов",
          exclusiveMedicines: "{{count}} эксклюзивных",
          cheapest: "{{pct}} дешевле",
          promo: "{{pct}} акционных",
          daysActive: "{{days}}/90 дней активен",
        },
        seeMetrics: "Метрики",
        metricsDrawerTitle: "Метрики",
        drilldown: {
          openAria: "Показать {{count}} препаратов: {{metric}}, {{organization}}",
          title: { exclusive: "эксклюзивные", cheapest: "самые дешёвые", promotion: "акционные" },
          description: {
            exclusive: "Препараты только этого поставщика за последние {{days}} дней.",
            cheapest: "Препараты с самой низкой ценой поставщика за последние {{days}} дней.",
            promotion: "Акционные предложения поставщика за последние {{days}} дней.",
          },
          summary: { matches: "Совпадения", medicines: "Препараты", window: "Период" },
          columns: {
            medicine: "Препарат",
            daysOffered: "Дней в продаже",
            offers: "Предложения",
            price: "Цена",
            runnerUp: "Следующая цена",
            delta: "Разница",
            promo: "Акция",
            issued: "Последнее",
            expiry: "Срок годности",
            vendor: "Производитель",
          },
          competitors: "среди {{count}} поставщиков",
          daysWindow: "{{count}} дн.",
          searchPlaceholder: "Поиск препаратов",
          clearSearch: "Очистить поиск",
          sortLabel: "Сортировка препаратов",
          sortOptions: {
            matched_days: "Дни в продаже",
            matched_offers: "Предложения",
            last_matched_date: "Последнее",
            matched_price: "Цена",
          },
          errorTitle: "Не удалось загрузить препараты",
          emptyTitle: "Подходящих препаратов нет",
          emptyDescription: {
            exclusive: "За этот период эксклюзивных препаратов не найдено.",
            cheapest: "За этот период препаратов с минимальной ценой не найдено.",
            promotion: "За этот период акционных препаратов не найдено.",
          },
        },
      },
      salesHover: {
        unknownMedicine: "Препарат",
        missingMedicineId: "К этой строке не привязан препарат (medicine_id).",
        loadError: "Не удалось загрузить данные о продажах.",
        daysIncluded: "дней учтено",
        chartTitle: "Розничные продажи",
        noData: "Данных о продажах нет.",
        avgDailySales: "Среднее за 90 дней",
        medianDailySales: "Медиана за 90 дней",
        totalSales: "Всего продано",
        includedDays: "Учтено дней",
        rank: "Место",
        percentile: "Процентиль",
        totalDiffVsMedian: "Всего относительно медианы конкурентов",
        dailyDiffVsMedian: "В день относительно медианы конкурентов",
        atcLeaders: "Лидеры по тому же ATC коду",
        avgPerPharmacy: "Ср. продажи / аптека",
        daysWithSales: "дн. с продажами",
        legend: {
          sales: "Продано",
          gain: "Пополнено",
          net: "Чистое",
          peerMedian: "Медиана по ATC коду",
        },
      },
      team: {
        roles: {
          owner: "Владелец",
          admin: "Администратор",
          member: "Участник",
        },
        members: {
          title: "Участники команды",
          description: "Пользователи с доступом к организации.",
          columns: {
            name: "Имя",
            phone: "Телефон",
            role: "Роль",
            joinedAt: "Дата добавления",
          },
          empty: "Пока нет участников.",
          remove: "Удалить",
          removeConfirm: {
            title: "Удалить участника?",
            description: "{{name}} потеряет доступ к организации.",
            confirm: "Удалить",
          },
          removeSuccess: "Участник удалён.",
          removeError: "Не удалось удалить участника.",
          removeForbidden: "У вас нет прав на удаление этого участника.",
          removeSelfForbidden: "Нельзя удалить самого себя.",
        },
        invitations: {
          title: "Приглашения",
          description: "Срок действия приглашений истекает автоматически.",
          empty: "Нет ожидающих приглашений.",
          invite: "Пригласить",
          copyLink: "Скопировать ссылку",
          revoke: "Отозвать",
          revokeSuccess: "Приглашение отозвано.",
          revokeError: "Не удалось отозвать приглашение.",
          revokeConflict: "Это приглашение больше нельзя отозвать.",
          columns: {
            phone: "Телефон",
            email: "Email",
            role: "Роль",
            expiresAt: "Истекает",
          },
          form: {
            title: "Пригласить участника",
            description: "Отправьте ссылку-приглашение на номер телефона.",
            phone: "Телефон",
            email: "Email (необязательно)",
            emailPlaceholder: "name@example.com",
            role: "Роль",
            submit: "Создать приглашение",
            submitting: "Создание…",
            success: "Приглашение создано.",
            errors: {
              phoneRequired: "Введите телефон.",
              phoneInvalid: "Введите корректный номер.",
              emailInvalid: "Введите корректный email.",
              duplicate: "Этот телефон уже приглашён или является участником.",
              generic: "Не удалось создать приглашение.",
            },
          },
          copy: {
            title: "Ссылка-приглашение",
            description: "Поделитесь этой ссылкой с {{phone}}, чтобы пригласить в команду.",
            done: "Готово",
            error: "Не удалось скопировать ссылку.",
          },
        },
        joinRequests: {
          title: "Заявки на вступление",
          description: "Пользователи, желающие присоединиться к организации.",
          columns: {
            name: "Имя",
            phone: "Телефон",
            requestedAt: "Подана",
          },
          approve: "Принять",
          reject: "Отклонить",
          approveSuccess: "Заявка принята.",
          approveError: "Не удалось принять заявку.",
          rejectSuccess: "Заявка отклонена.",
          rejectError: "Не удалось отклонить заявку.",
          alreadyDecided: "Эта заявка уже обработана.",
        },
      },
      join: {
        title: "Присоединиться к организации",
        description: "Найдите организацию и отправьте заявку на вступление.",
        greeting: "Здравствуйте, {{name}}. Найдите организацию для отправки заявки.",
        searchPlaceholder: "Искать организации…",
        empty: "Начните вводить, чтобы найти организацию.",
        noResults: "Организации не найдены.",
        requestButton: "Отправить заявку",
        requestSuccess: "Заявка отправлена.",
        requestError: "Не удалось отправить заявку.",
        errors: {
          alreadyInOrg: "Вы уже состоите в организации.",
          alreadyPending: "У вас уже есть активная заявка.",
        },
      },
      pending: {
        title: "Заявка на рассмотрении",
        description: "Ваша заявка на вступление ожидает одобрения менеджера.",
        targetLabel: "Организация",
        cancel: "Отозвать заявку",
        cancelSuccess: "Заявка отозвана.",
        cancelError: "Не удалось отозвать заявку.",
      },
    },
    wholesaleOffers: {
      title: "Оптовые предложения",
      totalRows: "{{count}} предложений",
      emptyTitle: "Предложения не найдены",
      emptyDescription: "Попробуйте сбросить фильтр по организации или зайдите позже.",
      badges: {
        supplement: "Добавка",
      },
      footerSummary: {
        offers: "{{count}} предложений",
        medicines: "{{count}} препаратов",
        organizations: "{{count}} организаций",
      },
      promoBadge: "Акция",
      promo: {
        popup: {
          ariaLabel: "Детали акции",
          defaultTitle: "Акция",
          priceLabel: "Цена",
          discount: "−{{pct}}%",
          combo: "Купи {{buy}}, получи {{bonus}} бесплатно",
          bonusMedicine: "Бонус: {{name}}",
          validFromThrough: "Действует {{start}} – {{end}}",
        },
      },
      expiresIn_one: "Истекает через {{count}} месяц",
      expiresIn_few: "Истекает через {{count}} месяца",
      expiresIn_many: "Истекает через {{count}} месяцев",
      expiresIn_zero: "Истекает в этом месяце",
      expired: "Срок истёк",
      batchAge: {
        noExpiry: "Нет срока",
        tooltip: "Предполагаемый возраст по оптовику, лекарству и сроку годности. Это не настоящий ID партии/лота.",
      },
      leaders: {
        title: "Лидеры",
        empty: "Недостаточно истории конкурирующих предложений.",
        headers: {
          supplier: "Поставщик",
          wins: "Победы",
          rate: "Доля",
          price: "Цена",
        },
        best: "Лучшая",
        rankTooltip: "Место в рейтинге за выбранный период.",
        winsTooltip:
          "Самая низкая цена в {{wins}} из {{dates}} сравниваемых дат. Из них {{ties}} побед с одинаковой ценой.",
        rateTooltip: "Доля сравниваемых дат, когда у поставщика была самая низкая цена.",
        currentPriceTooltip: "Текущая цена: {{price}} сум.",
        bestPriceTooltip: "Текущая цена: {{price}} сум — лучшее текущее предложение.",
        priceGapTooltip: "Текущая цена: {{price}} сум — на {{gap}} сум выше лучшего текущего предложения.",
        noCurrentPriceTooltip: "Нет предложения на текущую дату.",
        noCurrentPriceLastWinTooltip: "Нет предложения на текущую дату. Последняя победа: {{date}}.",
      },
      actions: {
        cheapestOffer: "Самое дешёвое предложение",
        mostExpensiveOffer: "Самое дорогое предложение",
        addToCart: "Корзина",
        removeFromCart: "Удалить из корзины",
        decreaseQuantity: "Уменьшить количество",
        increaseQuantity: "Увеличить количество",
        showPricePlan: "Показать прайс-лист",
        showExpirationObservations: "Показать наблюдения сроков",
        openMedicine: "Открыть лекарство",
        openOrganization: "Перейти к организации",
        openVendor: "Перейти к производителю",
        openReferentPrice: "Открыть референтную цену",
        showOnlyMedicine: "Показать только это лекарство",
        showCheaperSameMedicine: "Дешевле это же лекарство",
        showCheaperAnalogue: "Более дешёвый аналог",
        cheaperSavingsLine: "Экономия {{amount}} сум ({{percent}}%) · {{price}} сум",
        rawName: "Исходное название",
        showOnlyOrganization: "Показать только эту организацию",
        showPurchaseHistory: "История покупок",
      },
      purchaseHistory: {
        title: "Куплено ранее",
        totalSummary: "Всего куплено: {{count}} шт.",
        orderRow: "Заказ #{{shortId}}",
        orderQuantity: "{{count}} шт.",
        empty: "Нет предыдущих покупок этого товара.",
      },
      tone: {
        cheaper: "Дешевле рынка",
        moreExpensive: "Дороже рынка",
      },
      toneTooltip: {
        cheaper: "Это предложение на {{percent}}% дешевле средней рыночной цены.",
        moreExpensive: "Это предложение на {{percent}}% дороже средней рыночной цены.",
      },
      marketTrend: {
        down: "Рынок снижается",
        up: "Рынок растёт",
        tooltip: "Тренд средней рыночной цены за 90 дней для этого лекарства и условий оплаты.",
      },
      indicators: {
        cheapestAmongAnalogues: "Самое дешёвое среди аналогов",
        onlyAnalogousOffer: "Единственное предложение среди аналогов",
      },
      outlierWarning: "Эта цена выглядит необычной и может быть неверной.",
      referentPriceCapturedOn: "Зафиксировано {{date}}",
      referentPriceCurrentTooltip: "Текущая референтная цена (действует с {{date}})",
      referentPriceUpcomingTooltip: "{{price}} вступает в силу {{date}}",
      referentPriceUpcomingLabel: "с {{date}}",
      variationFilters: {
        hideInactive: "Скрыть неактивные",
        showAll: "Показать все",
        dosageForm: "Форма",
        strength: "Дозировка",
        volume: "Объём",
        pack: "Упаковка",
        containerType: "Тара",
        productType: "Тип",
      },
      columns: {
        medicine: "Лекарство",
        organization: "Организация",
        region: "Регион",
        vendor: "Производитель",
        price: "Цена с НДС",
        normalizedUnitPrice: "Цена за ед.",
        markup: "Наценка",
        referentWholesalePrice: "Реф. опт",
        referentRetailPrice: "Реф. розница",
        issueDate: "Дата предложения",
        expiryDate: "Срок",
        batchAge: "Возраст партии",
        promotion: "Акция",
      },
      columnsMenu: {
        label: "Колонки",
        presets: {
          wholesale: "Опт",
          retail: "Розница",
        },
      },
      filters: {
        organizationPlaceholder: "Фильтр по организации",
        organizationSearchPlaceholder: "Поиск организаций...",
        organizationEmpty: "Организации не найдены",
        clearOrganization: "Сбросить фильтр",
        organizationIncludedCount_one: "{{count}} выбрана",
        organizationIncludedCount_few: "{{count}} выбрано",
        organizationIncludedCount_many: "{{count}} выбрано",
        organizationIncludedCount_other: "{{count}} выбрано",
        organizationExcludedCount_one: "{{count}} исключена",
        organizationExcludedCount_few: "{{count}} исключено",
        organizationExcludedCount_many: "{{count}} исключено",
        organizationExcludedCount_other: "{{count}} исключено",
        organizationIncludeAction: "Включить",
        organizationExcludeAction: "Исключить",
        medicinePlaceholder: "Фильтр по лекарству",
        medicineSearchPlaceholder: "Поиск лекарств...",
        medicineEmpty: "Лекарства не найдены",
        medicineShowAll: "Показать все «{{query}}»",
        medicineShowAllLabel: "Поиск: {{query}}",
        clearMedicine: "Сбросить фильтр",
        regionPlaceholder: "Фильтр по региону",
        regionSearchPlaceholder: "Поиск регионов...",
        regionEmpty: "Регионы не найдены",
        clearRegion: "Сбросить фильтр региона",
        clearAll: "Сбросить",
        hasPromotion: "Акция",
        withAnalogous: "С аналогами",
        cheapestPerMedicine: "Дешёвые",
        paymentPercentage: "Процент оплаты",
        paymentPercentageTooltip: "Процент предоплаты",
        paymentOption: "{{value}}%",
        payment100: "Предоплата 100%",
        payment25: "25% оплатой",
        supplement: "Добавки",
        hidePriceDecimals: "Скрыть дробные",
        highlighted_one: "{{count}} выделено",
        highlighted_few: "{{count}} выделено",
        highlighted_many: "{{count}} выделено",
        highlighted_other: "{{count}} выделено",
      },
      legend: {
        ariaLabel: "Показать легенду точек и значков",
        title: "Что означают точки и значки",
        rowColors: {
          heading: "Точки статуса предложения",
          onlyOffer: "Единственное предложение по этому лекарству",
          cheapest: "Самое дешёвое предложение по этому лекарству, не включая аналоги",
          mostExpensive: "Самое дорогое предложение по этому лекарству",
        },
        statusFilters: {
          cheapest: "Самое дешёвое",
          mostExpensive: "Самое дорогое",
          onlyOffer: "Единственное предложение",
          notInMarket: "Нет на рынке",
        },
        priceTone: {
          heading: "Цена относительно медианы рынка",
        },
        indicators: {
          heading: "Обозначения",
          outlier: "Цена выглядит необычно — проверьте перед покупкой",
          promo: "Предложение с акцией (скидка или купи N + получи M)",
        },
      },
      priceHistoryModal: {
        title: "История",
        current: "Текущая цена",
        periodMin: "Мин за период",
        periodMax: "Макс за период",
        change: "Изменение за период",
        wholesaleRetailSavings: "Разница опт/розница",
        priceDifferenceCheaperTooltip: "Средняя оптовая цена ниже розничной.",
        priceDifferenceMoreExpensiveTooltip: "Средняя оптовая цена выше розничной.",
        priceDifferenceSameTooltip: "Средние оптовая и розничная цены совпадают.",
        referentWholesale: "Референт (опт)",
        referentRetail: "Референт (розница)",
        periodSelector: "Период",
        daysUnit: "дней",
        offerCount: "Кол-во предложений",
        offerCountSwitch: "Показать кол-во предложений",
        dateOffers: "Предложения по датам",
        tabs: {
          wholesale: "Оптовые",
          retail: "Розничные",
          expirationObservations: "Наблюдения сроков",
        },
        daysWindow: "За последние {{count}} дней",
        series: {
          median: "Медиана",
          min: "Мин",
          max: "Макс",
          avg: "Ср.",
        },
        loadError: "Не удалось загрузить историю цен.",
        empty: "История цен недоступна.",
        hoverHint: "Наведите на дату, чтобы увидеть предложения за этот день.",
        offersOnDate: "Предложения за {{date}}",
        offersError: "Не удалось загрузить предложения за эту дату.",
        noOffers: "Предложений за эту дату нет.",
        offerAgeLabel_one: "{{count}} день назад",
        offerAgeLabel_few: "{{count}} дня назад",
        offerAgeLabel_many: "{{count}} дней назад",
        offerAgeLabel_other: "{{count}} дней назад",
        offerAgeTooltip:
          "Это предложение из последнего известного более раннего прайс-листа; оно показано для этой даты, потому что более позднее изменение цены или удаление ещё не было известно.",
        batchAge: {
          title: "Давность партии",
          description:
            "Предполагаемый возраст по оптовику, лекарству и сроку годности. Это не настоящий ID партии/лота.",
          summaryOldest: "Самая старая текущая",
          summaryAverage: "Средняя текущая",
          summaryWholesalers: "Оптовики",
          currentExpiry: "Текущий срок: {{date}}",
          firstSeen: "Впервые замечено {{date}}",
          observations: "{{count}} наблюдений",
          timeline: "Лента периодов срока годности",
          legendPrefix: "Лента:",
          legendFresh: "< 30 д",
          legendAging: "30-59 д",
          legendStale: "60+ д",
          legendNoExpiry: "Нет срока",
          legendLowerBound: "нижняя граница",
          legendWidth: "Чем шире период, тем дольше срок годности оставался неизменным.",
          segmentRange: "{{start}} - {{end}}",
          segmentAge: "Предполагаемый возраст: {{age}}",
          segmentObservations: "{{count}} наблюдений",
          segmentHint: "Ширина сегмента показывает, как долго это значение срока годности не менялось.",
          noRuns: "Периоды срока годности не записаны.",
          empty: "Данные о давности партии недоступны.",
          error: "Не удалось загрузить давность партии.",
        },
      },
    },
    invitations: {
      accept: {
        invalidLink: {
          title: "Некорректная ссылка",
          description: "Ссылка отсутствует или повреждена.",
        },
        redirecting: "Переход на вход…",
        processing: "Принимаем приглашение…",
        success: {
          title: "Готово!",
          description: "Теперь вы участник организации {{name}}.",
          descriptionFallback: "Теперь вы участник организации.",
          continue: "Продолжить",
        },
        errors: {
          goHome: "К панели",
          phoneMismatch: {
            title: "Номер телефона не совпадает",
            description:
              "Это приглашение было отправлено на другой номер. Вы вошли как {{phone}}. Выйдите и войдите с приглашённым номером.",
          },
          notFound: {
            title: "Приглашение не найдено",
            description: "Эта ссылка-приглашение неизвестна или была удалена.",
          },
          conflict: {
            title: "Уже состоите в организации",
            description: "Сначала покиньте текущую организацию, затем примите приглашение.",
          },
          expired: {
            title: "Срок приглашения истёк",
            description: "Попросите отправить новое приглашение.",
          },
          generic: {
            title: "Не удалось принять приглашение",
            description: "Попробуйте позже.",
          },
        },
      },
    },
    vendors: {
      list: {
        searchPlaceholder: "Поиск производителей",
        loadErrorTitle: "Не удалось загрузить производителей",
        emptyTitle: "Производители не найдены",
        emptyDescription: "Попробуйте другой поисковый запрос.",
        countryMissing: "Страна не указана",
      },
      info: {
        chooseVendor: "Выберите производителя",
        detailsHint: "Выберите производителя слева, чтобы посмотреть детали.",
        country: "Страна",
        website: "Сайт",
        email: "Email",
        phone: "Телефон",
        address: "Адрес",
        description: "Описание",
        notAvailable: "Недоступно",
        idLabel: "ID",
        copyId: "Скопировать ID",
        idCopied: "ID скопирован",
      },
      label: {
        name: "Производитель",
        country: "Страна",
        countryUnknown: "Страна не указана",
      },
    },
    certifiedMedicines: {
      title: "Сертификаты",
      totalRows: "{{count}} записей",
      emptyTitle: "Сертификаты не найдены",
      emptyDescription: "Попробуйте изменить запрос или сбросить фильтры.",
      loadErrorTitle: "Не удалось загрузить сертификаты",
      filters: {
        searchPlaceholder: "Поиск по названию, производителю, номеру…",
        yearPlaceholder: "Год",
        allYears: "Все годы",
        countryPlaceholder: "Страна",
        allCountries: "Все страны",
        countrySearchPlaceholder: "Поиск стран…",
        countryEmpty: "Страны не найдены",
        certifyingBodyPlaceholder: "Орган сертификации",
        allCertifyingBodies: "Все органы",
        shelfLifePlaceholder: "Срок годности",
        shelfLifeFromPlaceholder: "Начало",
        shelfLifeToPlaceholder: "Конец",
        shelfLifeApply: "Применить",
        shelfLifeReset: "Сбросить",
        medicineFilter: "Лекарство",
        clearAll: "Сбросить",
        unknownOrganization: "Неизвестная организация",
        dialogTitle: "Фильтры",
        dialogDone: "Готово",
        clearSearch: "Очистить поиск",
      },
      columns: {
        productName: "Название",
        year: "Год",
        manufacturer: "Производитель",
        manufacturerCountry: "Страна",
        certifyingBody: "Орган сертификации",
        batchSeries: "Серия партии",
        registrationNumber: "Рег. №",
        certificateIssuedAt: "Дата сертификата",
        shelfLifeDate: "Срок годности",
        orderedBy: "Заявитель",
      },
      actions: {
        openMedicine: "Открыть препарат",
      },
      detail: {
        title: "Детали сертификата",
        description: "Полная запись сертификата",
        id: "ID записи",
        crawledAt: "Собрано",
        openSource: "Открыть на uzpharm-control.uz",
      },
    },
    referentPrices: {
      title: "Референтные цены",
      emptyTitle: "Референтные цены не найдены",
      emptyDescription: "Попробуйте другой запрос или сбросьте фильтры.",
      loadErrorTitle: "Не удалось загрузить референтные цены",
      unmatched: "Не сопоставлено",
      filters: {
        searchPlaceholder: "Поиск по названию, производителю, рег. номеру…",
        currencyPlaceholder: "Валюта",
        allCurrencies: "Все валюты",
        matchStatusPlaceholder: "Сопоставление",
        allMatchStatuses: "Все",
        matched: "Сопоставлены",
        unmatched: "Не сопоставлены",
        clearAll: "Сбросить",
      },
      columns: {
        tradeName: "Торговое название",
        internationalName: "МНН",
        manufacturer: "Производитель",
        package: "Упаковка",
        registrationNumber: "Номер регистрации",
        currency: "Валюта",
        referentPrice: "Предельная цена",
        wholesalePrice: "Оптовая (сум)",
        retailPrice: "Розничная (сум)",
        matchedMedicine: "Препарат",
      },
      actions: {
        openMedicine: "Открыть препарат",
      },
      currencies: {
        UZS: "Сум",
        USD: "Доллар",
        EUR: "Евро",
        RUB: "Рубль",
      },
      detail: {
        title: "Детали референтной цены",
        description: "Полная запись референтной цены",
      },
    },
    expiryStatus: {
      active: "Действителен",
      expiringSoon: "Скоро истекает",
      expired: "Просрочен",
    },
    notifications: {
      newPriceList: "Новый прайс-лист: {{count}} предложений",
      pricesUpdated: "Цены обновлены",
      pricesUpdatedFor: "Цены обновлены — {{organization}}",
      offerCount_one: "{{count}} предложение",
      offerCount_few: "{{count}} предложения",
      offerCount_many: "{{count}} предложений",
      offerCount_other: "{{count}} предложений",
      date: "Дата: {{date}}",
      region: "Регион: {{region}}",
    },
    cart: {
      title: "Корзина",
      description: "Лекарства в корзине",
      defaultItemLabel: "Товар",
      clearCart: "Очистить корзину",
      clearConfirm: {
        title: "Очистить корзину?",
        description: "Все товары будут удалены из корзины. Это действие нельзя отменить.",
      },
      cleared: "Корзина очищена",
      removed: "{{name}} удалён из корзины",
      added: "{{name}} добавлен в корзину",
      inCartTooltip: "Добавлено в корзину",
      batchAdded: "{{count}} товаров добавлено в корзину",
      medicineName: "Лекарство",
      supplier: "Поставщик",
      manufacturer: "Производитель",
      quantity: "Количество",
      price: "Цена",
      total: "Итого",
      itemCount: "{{count}} лекарств",
      totalAmount: "Общая сумма",
      beforeDiscount: "До скидки",
      youSaved: "Вы сэкономили",
      priceReason: {
        title: {
          promo: "Акционная скидка",
          combo: "Комбо-акция",
          priceDropped: "Поставщик снизил цену",
          priceIncreased: "Поставщик повысил цену",
        },
        priceDroppedFromTo: "Было {{from}}, стало {{to}}",
        priceIncreasedFromTo: "Было {{from}}, стало {{to}}",
        comboEffectiveUnit: "Эффективная цена за штуку: {{price}}",
        comboFreeUnits_one: "В строке учтена {{count}} бесплатная единица",
        comboFreeUnits_few: "В строке учтены {{count}} бесплатные единицы",
        comboFreeUnits_many: "В строке учтено {{count}} бесплатных единиц",
        comboFreeUnits_other: "В строке учтено {{count}} бесплатных единиц",
        totalsBreakdownTitle: "Как вы сэкономили",
        totalsBreakdownReason: {
          promo: "акция",
          combo: "комбо {{buy}}+{{bonus}}",
          priceDropped: "снижение цены",
        },
        totalsBreakdownLineSaved: "сэкономлено {{amount}}",
      },
      compactPrices: "Показывать цены в миллионах (1 000 000 → 1m)",
      expiryDate: "Срок: {{date}}",
      issueDate: "Выпущено: {{date}}",
      swap: {
        title: "Сменить поставщика",
        cheaperAvailable: "Доступно более дешёвое предложение",
        description: "Выберите другого поставщика для {{name}}",
        cheaper: "Дешевле на {{percent}}%",
        moreExpensive: "Дороже на {{percent}}%",
        same: "та же цена",
        replace: "Заменить",
        empty: "Альтернативные поставщики или аналоги не найдены",
        replaced: "Поставщик заменён на {{name}}",
        replacedAnalogue: "Заменено на {{medicine}} от {{name}}",
        currentLabel: "Текущий",
        analogueLabel: "Аналог",
        bestPrice: "Лучшая цена",
        save: "Экономия {{amount}}",
        onlyCheaper: "Только дешевле",
      },
      promo: {
        suggestionsTitle: "Доступны бесплатные товары",
        bumpQuantity: "Добавьте ещё {{delta}} {{name}}, чтобы получить {{bonus}} бесплатно",
        bumpForCrossBonus: "Добавьте ещё {{delta}} {{name}}, чтобы получить {{bonusQuantity}} бесплатных {{bonusName}}",
        bumpAction: "Увеличить количество",
        addBonus: "Вы получаете {{bonus}} бесплатных {{name}}",
        addBonusAction: "Добавить в корзину",
        dismiss: "Закрыть",
        openButton: "Акции",
        modalTitle: "Акции в вашей корзине",
        modalDescription: "Прогресс по каждому бонусу",
        noPromos: "В корзине нет товаров с акциями.",
        selfBonusFormula: "Купите {{buy}}, получите {{bonus}} бесплатно того же товара",
        crossBonusFormula: "Купите {{buy}} {{name}}, получите {{bonus}} бесплатных {{bonusName}}",
        bonusItemFallback: "бонусный товар",
        progressInCart: "{{count}} в корзине",
        bonusUnlocked_one: "{{count}} бесплатно получено",
        bonusUnlocked_few: "{{count}} бесплатных получено",
        bonusUnlocked_many: "{{count}} бесплатных получено",
        bonusUnlocked_other: "{{count}} бесплатных получено",
        bonusClaimed: "Бонус уже в корзине",
        unitsToUnlockSelf_one: "Добавьте ещё 1, чтобы получить {{bonus}} бесплатно",
        unitsToUnlockSelf_few: "Добавьте ещё {{count}}, чтобы получить {{bonus}} бесплатно",
        unitsToUnlockSelf_many: "Добавьте ещё {{count}}, чтобы получить {{bonus}} бесплатно",
        unitsToUnlockSelf_other: "Добавьте ещё {{count}}, чтобы получить {{bonus}} бесплатно",
        unitsToUnlockCross_one: "Добавьте ещё 1, чтобы получить {{bonus}} бесплатных {{bonusName}}",
        unitsToUnlockCross_few: "Добавьте ещё {{count}}, чтобы получить {{bonus}} бесплатных {{bonusName}}",
        unitsToUnlockCross_many: "Добавьте ещё {{count}}, чтобы получить {{bonus}} бесплатных {{bonusName}}",
        unitsToUnlockCross_other: "Добавьте ещё {{count}}, чтобы получить {{bonus}} бесплатных {{bonusName}}",
      },
      combo: {
        bonus: "Бонус",
        bonusCount_one: "+{{count}}",
        bonusCount_few: "+{{count}}",
        bonusCount_many: "+{{count}}",
        bonusCount_other: "+{{count}}",
      },
      empty: {
        title: "Корзина пуста",
        description: "Добавьте лекарства со страницы поиска",
        goToMedicines: "Перейти к лекарствам",
      },
      autoSelection: {
        choose: "В корзине уже {{activeCount}} позиций. Заменить её или добавить {{recommendationCount}} рекомендаций?",
        merge: "Объединить",
        replace: "Заменить корзину",
        unpriced_one: "Для {{count}} позиции нужно выбрать поставщика.",
        unpriced_few: "Для {{count}} позиций нужно выбрать поставщика.",
        unpriced_many: "Для {{count}} позиций нужно выбрать поставщика.",
        unpriced_other: "Для {{count}} позиций нужно выбрать поставщика.",
      },
      optimize: {
        title: "Оптимизация цен",
        description: "Найдите лучшие цены на лекарства в корзине",
        cheapest: {
          title: "Самые низкие цены",
          description: "Минимальная цена для каждого лекарства",
          issueDate: "Дата",
          notFound: "Предложения не найдены для {{count}} лекарств",
          empty: "Предложения не найдены",
          applyAll: "Применить все",
          applied: "Самые низкие цены применены",
        },
        maximumTotal: "Максимальная сумма заказа (UZS)",
        maximumTotalDescription: "Укажите лимит покупки, затем пересчитайте все планы с уменьшенными количествами.",
        setMaximumTotal: "Установить максимум заказа",
        unlimited: "Без ограничения",
        recalculate: "Пересчитать планы",
        combinations: {
          title: "Комбинации оптовиков",
          description: "Варианты покупки из меньшего числа оптовиков",
          option: "Вариант {{index}}",
          suppliers: "{{count}} оптовиков",
          extraCost: "+{{amount}} дополнительно",
          usePlan: "Выбрать",
          applied: "Вариант применён",
          empty: "Комбинации не найдены",
          requiresMoreOrgs: "Лучшим вариантам требуется более {{count}} оптовиков; результаты ниже неполные.",
          earliestExpiry: "Ближайший срок: {{date}}",
          missingExpiry: "У {{count}} позиций нет срока годности",
          bestBy: {
            price: "Лучший по цене",
            organization_count: "Минимум оптовиков",
            expiry: "Лучший по сроку",
          },
        },
        mode: {
          label: "Оптимизировать по",
          price: "Цене",
          organization_count: "Оптовикам",
          expiry: "Сроку годности",
          all: "Всё",
        },
        backToCart: "Вернуться в корзину",
        error: "Произошла ошибка",
      },
      analyze: {
        title: "Анализ цен",
        description: "Сравните цены в корзине с рыночными данными",
        backToCart: "Вернуться в корзину",
        cartPrice: "Цена в корзине",
        marketMin: "Мин. на рынке",
        recommended: "Рекомендуемая",
        referentWholesale: "Референт (опт)",
        referentRetail: "Референт (розница)",
        vsMedian: "от медианы",
        offers: "Предложения",
        aboveMedian: "+{{percent}}% ▲",
        belowMedian: "−{{percent}}% ▼",
        atMedian: "0%",
        notSet: "Не указана",
        noData: "Нет рыночных данных",
        limitedData: "Мало данных",
        good: "Хорошая цена",
        warning: "Высокая цена",
      },
      stale: {
        banner: {
          title: "Некоторые товары устарели",
          description_one: "{{count}} товар нужно обновить перед оформлением.",
          description_few: "{{count}} товара нужно обновить перед оформлением.",
          description_many: "{{count}} товаров нужно обновить перед оформлением.",
          description_other: "{{count}} товаров нужно обновить перед оформлением.",
        },
        refreshSelected: "Обновить выбранные",
        refreshAll: "Обновить все устаревшие",
        refreshing: "Обновление…",
        selectAll: "Выбрать все устаревшие",
        reason: {
          price_changed: "Цена изменилась: {{from}} → {{to}}",
          issue_date_changed: "Дата выпуска изменилась: {{from}} → {{to}}",
          price_list_file_changed: "Прайс-лист обновлён ({{date}})",
          price_list_file_changed_no_date: "Прайс-лист обновлён",
          offer_removed: "Предложение больше недоступно — удалите или замените товар",
          no_offer_data: "Нет актуальных данных — удалите или замените товар",
          stale: "Данные товара устарели",
        },
        outcome: {
          summary: "{{updated}} обновлено, {{unchanged}} без изменений, {{unresolved}} не обновлено",
          allUpdated: "Все выбранные товары обновлены",
          unresolved: "Не удалось обновить — предложение пропало; удалите или замените товары",
        },
      },
      priceChangeWarning: {
        title: "Цены изменились",
        description_one:
          "У {{count}} товара цена отличается от той, что вы видели. Проверьте изменения перед оформлением заказа.",
        description_few:
          "У {{count}} товаров цены отличаются от тех, что вы видели. Проверьте изменения перед оформлением заказа.",
        description_many:
          "У {{count}} товаров цены отличаются от тех, что вы видели. Проверьте изменения перед оформлением заказа.",
        description_other:
          "У {{count}} товаров цены отличаются от тех, что вы видели. Проверьте изменения перед оформлением заказа.",
        unavailableTitle: "Предложения больше недоступны",
        unavailableDescription_one:
          "У {{count}} товара предложение больше не существует. Удалите или замените товар перед оформлением заказа.",
        unavailableDescription_few:
          "У {{count}} товаров предложения больше не существуют. Удалите или замените товары перед оформлением заказа.",
        unavailableDescription_many:
          "У {{count}} товаров предложения больше не существуют. Удалите или замените товары перед оформлением заказа.",
        unavailableDescription_other:
          "У {{count}} товаров предложения больше не существуют. Удалите или замените товары перед оформлением заказа.",
        unavailable: "Больше недоступно — удалите или замените товар",
        continue: "Продолжить с новыми ценами",
      },
    },
    checkout: {
      button: "Оформить заказ",
      title: "Подтверждение заказа",
      description: "Проверьте и подтвердите ваш заказ",
      confirm: "Оформить",
      cancel: "Отмена",
      notes: "Примечание (необязательно)",
      notesPlaceholder: "Добавьте примечание к заказу...",
      warning: "Все товары должны иметь поставщика, цену и дату выпуска.",
      success: "Заказ успешно создан",
      incompleteItems: "Некоторые товары в корзине не заполнены полностью.",
      staleItems: "Некоторые товары устарели. Обновите их перед оформлением.",
      staleWarning: "Товары ниже устарели — обновите их на странице корзины перед оформлением.",
    },
    orders: {
      title: "Заказы",
      description: "История заказов",
      downloadFormats: {
        excel: "Excel",
        excelZip: "Excel (ZIP)",
        pdf: "PDF",
      },
      order: "Заказ",
      orderId: "ID заказа",
      date: "Дата",
      statusLabel: "Статус",
      suppliers: "Поставщики",
      totalPrice: "Итого",
      grandTotal: "Общий итог",
      subtotal: "Подитог",
      notes: "Примечание",
      medicine: "Лекарство",
      vendor: "Производитель",
      quantity: "Кол-во",
      unitPrice: "Цена",
      lineTotal: "Итого",
      download: "Скачать",
      expiry: "Срок: {{date}}",
      issued: "Выпущено: {{date}}",
      itemCount: "{{count}} товаров",
      backToOrders: "Назад к заказам",
      notFound: "Заказ не найден",
      notFoundDescription: "Заказ, который вы ищете, не существует или был удалён.",
      pageInfo: "Страница {{page}} из {{total}}",
      status: {
        pending: "Ожидание",
        confirmed: "Подтверждён",
        partially_fulfilled: "Частично выполнен",
        fulfilled: "Выполнен",
        cancelled: "Отменён",
      },
      subOrderStatus: {
        pending: "Ожидание",
        confirmed: "Подтверждён",
        shipped: "Отправлен",
        delivered: "Доставлен",
        cancelled: "Отменён",
      },
      empty: {
        title: "Заказов пока нет",
        description: "Ваши заказы появятся здесь после оформления",
        goToCart: "Перейти в корзину",
      },
      reorder: {
        action: "Заказать снова",
        confirmTitle: "Заменить текущую корзину?",
        confirmDescription: "Это очистит текущую корзину и добавит товары из этого заказа.",
        cancel: "Отмена",
        confirmAction: "Заменить корзину",
        pending: "Замена...",
      },
    },
    orderImport: {
      title: "Импорт файлов заказов",
      description:
        "Перетащите один или несколько xlsx-файлов заказов (выгруженных со страницы Заказы). Мы агрегируем препараты, выбираем самого дешёвого поставщика и учитываем акции.",
      dropHint: "Перетащите xlsx-файлы сюда",
      fileTypes: "Поддерживаются: .xlsx, .xls — до 20 файлов",
      browse: "Выбрать файлы",
      remove: "Удалить файл",
      generate_one: "Сформировать оптимальную корзину из {{count}} файла",
      generate_few: "Сформировать оптимальную корзину из {{count}} файлов",
      generate_many: "Сформировать оптимальную корзину из {{count}} файлов",
      generate_other: "Сформировать оптимальную корзину из {{count}} файлов",
      success_one: "Импортировано. {{count}} препарат сопоставлен.",
      success_few: "Импортировано. {{count}} препарата сопоставлено.",
      success_many: "Импортировано. {{count}} препаратов сопоставлено.",
      success_other: "Импортировано. {{count}} препаратов сопоставлено.",
      error: "Не удалось импортировать заказы",
      goToOrderImport: "Импорт заказов",
      goToPriceImport: "Импорт прайс-листов",
      tabs: {
        priceLists: "Прайс-листы",
        orders: "Заказы",
      },
    },
    orderSheet: {
      backToImport: "К импорту",
      searchPlaceholder: "Найдите препарат, чтобы добавить актуальное предложение",
      searchHint: "Начните вводить название препарата, чтобы найти активные предложения оптовиков.",
      searching: "Поиск...",
      noResults: "Подходящих предложений нет.",
      title: "Оптимизированный заказ",
      importedTotal: "Сумма импорта",
      optimizedTotal: "После оптимизации",
      savingsVsImported: "Экономия vs. импорт",
      promoSavings: "Экономия по акциям",
      estimatedTotal: "Расчётная сумма закупки",
      pricedSubtotal: "Сумма позиций с ценой",
      medicineCount: "Препараты",
      supplierCount: "Поставщики",
      unavailableOffers: "Предложения для проверки",
      noSupplierOffer: "Нет предложения поставщика",
      missingOffersHint: "Для {{count}} препаратов нужно выбрать предложение",
      missingOffersTitle: "Для {{count}} препаратов нет предложения поставщика",
      missingOffersDescription:
        "Выберите предложение точного препарата или аналога либо удалите строку. Заказ и XLSX отключены, чтобы препараты не были незаметно пропущены.",
      budgetMaximum: "Лимит {{amount}}",
      budgetExceededTitle: "Заказ превышает доступный бюджет",
      budgetExceededDescription:
        "Текущая сумма — {{total}}, лимит — {{maximum}}. Уменьшите количество или выберите более дешёвых поставщиков перед заказом или экспортом.",
      allAbc: "Все ABC",
      allXyz: "Все XYZ",
      changeSupplier: "Сменить поставщика",
      changeSupplierTooltip: "Выберите поставщика точного препарата или аналога",
      supplierChanged: "Поставщик обновлён",
      supplierChangeFailed: "Не удалось сменить поставщика",
      selectedOfferUnavailable: "Выбранное предложение больше недоступно. Выберите другого поставщика.",
      automaticBestOffer: "Автоматически лучшее предложение",
      exactOffers: "Предложения точного препарата",
      analogueOffers: "Предложения аналогов",
      analogueBadge: "Аналог",
      analogueOfferNotice:
        "Аналоги показаны отдельно. При выборе количество упаковок может измениться, чтобы сохранить примерно то же число единиц.",
      analogueReplacement: "Заменяет {{original}}",
      unlimited: "Без ограничения",
      settings: {
        title: "Настройки расчёта",
        description: "Сохранённый снимок спроса и параметры заказа.",
        legacyDescription:
          "Этот старый черновик доступен только для просмотра. Создайте новый в POS для редактирования.",
        edit: "Изменить настройки",
        dialogTitle: "Настройки расчёта",
        dialogDescription: "После сохранения позиции будут пересчитаны по снимку данных на момент создания черновика.",
        history: "Период продаж",
        coverage: "Запас на период",
        leadTime: "Срок поставки",
        safety: "Страховой запас",
        minimumSales: "Минимум дней с продажами",
        maximumPacks: "Максимум упаковок на препарат",
        maximumTotal: "Максимальная сумма заказа (UZS)",
        snapshot: "Снимок создан",
        days: "{{count}} дн.",
        save: "Сохранить и пересчитать",
        recalculating: "Пересчёт...",
        recalculated: "Автоподбор пересчитан: {{count}} препаратов.",
        failed: "Не удалось пересчитать автоподбор.",
        quantityWarningTitle: "Изменённые количества будут заменены",
        quantityWarningDescription: "Выбранные поставщики, добавленные препараты и удаления сохранятся.",
      },
      classification: {
        abc: {
          A: "ABC A: высокая доля в сумме продаж; наиболее финансово важные препараты.",
          B: "ABC B: средняя доля в сумме продаж.",
          C: "ABC C: низкая доля в сумме продаж.",
        },
        xyz: {
          X: "XYZ X: стабильный и предсказуемый еженедельный спрос.",
          Y: "XYZ Y: умеренно изменчивый еженедельный спрос.",
          Z: "XYZ Z: нерегулярный или сильно изменчивый еженедельный спрос.",
        },
      },
      sort: {
        quantity: "Сортировка: количество",
        abc: "Сортировка: ABC",
        xyz: "Сортировка: XYZ",
        revenue: "Сортировка: сумма продаж",
        variability: "Сортировка: стабильность",
      },
      explanation: {
        open: "Объяснить рекомендуемое количество",
        title: "Как рассчитано количество",
        salesDays: "Дни с завершёнными продажами",
        period: "Период / дни продаж",
        periodValue: "{{history}} / {{sales}} дн.",
        sales: "Завершённые продажи",
        returns: "Завершённые возвраты",
        netDemand: "Чистый спрос",
        dailyRate: "Среднее в день",
        demandDays: "Покрытие + поставка + запас",
        targetStock: "Целевой остаток",
        currentStock: "Текущий остаток",
        shortage: "Нехватка",
        packSize: "Единиц в упаковке",
        initialPacks: "Исходно упаковок",
        inbound: "Подтверждено в пути",
        beforeMaximum: "После вычета поставок",
        maximum: "Лимит упаковок",
        minimumSalesDays: "Требуется дней продаж",
        generated: "Рекомендовано",
        orderBudget: "Максимальная сумма заказа",
        budgetRequested: "Упаковок до бюджета",
        budgetAdjusted: "Упаковок после бюджета",
        current: "Текущее количество",
        abcRevenue: "Продажи для ABC за 90 дней",
        abc: "ABC {{class}} · доля {{contribution}}% · накоплено {{cumulative}}%",
        xyz: "XYZ {{class}} · среднее за неделю {{average}} · вариативность {{variation}}% за {{weeks}} нед.",
        xyzInsufficient: "XYZ: недостаточно истории продаж",
      },
      supplierTotalRow: "{{count}} позиций · {{total}}",
      itemColumns: {
        medicine: "Препарат",
        supplier: "Поставщик",
        vendor: "Поставщик / производитель",
        quantity: "Кол-во",
        importedPrice: "Цена импорта",
        selectedPrice: "Цена",
        lineTotal: "Сумма",
        lineSavings: "Экономия по строке",
        expiry: "Срок годности",
        issueDate: "Дата выпуска",
        actions: "",
      },
      addProduct: "Добавить препарат",
      addProductDialogTitle: "Найдите препарат, чтобы добавить",
      createOrder: "Создать заказ",
      createOrderPending: "Создаём...",
      createOrderSuccess: "Заказ создан",
      removeRow: "Удалить",
      removeRowSuccess: "Удалено из листа",
      addRowSuccess: "Добавлено в лист",
      decreaseQty: "Уменьшить количество",
      increaseQty: "Увеличить количество",
      promoBadge: "Акция",
      unresolvedTitle: "Не удалось сопоставить",
      unresolvedDescription:
        "Эти строки не сопоставлены автоматически. Исправьте исходный xlsx (название/поставщика) и импортируйте заново.",
      unresolvedRow: "{{name}} · кол-во {{qty}} · из {{files}}",
      noOptimization: "Оптимизация недоступна для этого листа.",
      autoSelectionTitle: "Черновик автоподбора",
      autoSelectionClaiming: "Проверяем доступ к аптеке и открываем редактируемый заказ...",
      autoSelectionClaimError: "Ссылка истекла, относится к другой аптеке или требует прав администратора организации.",
      autoSelectionAuthError: "Войдите как владелец или администратор этой аптеки, чтобы открыть черновик.",
      autoSelectionRetry: "Повторить",
      autoSelectionSignIn: "Войти под другой учётной записью",
      autoSelectionReason: "Продано {{sold}} ед. за {{days}} дн. · остаток {{stock}} · в пути {{inbound}} упак.",
    },
    priceListFiles: {
      backToImport: "На главную",
      issue: "Выпуск",
      rows: "Строк",
      status: "Статус",
      itemsTitle: "Позиции прайс-листа",
      itemsSearchHint: "Поиск по строкам",
      searchPlaceholder: "Поиск по названию, коду или поставщику...",
      empty: "Для этого файла нет строк.",
      cols: {
        name: "Название",
        price: "Цена",
        markup: "Наценка",
        paymentPercentage: "Процент оплаты",
        expiry: "Срок",
        vendor: "Поставщик",
      },
    },
    overview: {
      loadFailed: "Не удалось загрузить аналитику",
      kpi: {
        medicines: "Препараты",
        medicinesDescription: "В рыночном каталоге",
        pharmacies: "Аптеки",
        pharmaciesDescription: "С данными розничных цен",
        approvedWholesalers: "Одобренные оптовики",
        wholesalersActive: "{{count}} активных",
        wholesalersActiveDescription: "С живыми оптовыми предложениями",
        liveWholesaleOffers: "Активные оптовые предложения",
        promotional: "{{count}} акций",
        liveWholesaleOffersDescription: "Сейчас активны на рынке",
      },
      retail: {
        title: "Розничное покрытие",
        snapshotLabel: "Препараты со снимком цены",
        snapshotHelp: "{{rate}}% каталога имеет актуальные розничные цены",
        deliveryLabel: "Аптеки с доставкой",
        ofCount: "из {{count}}",
        lastCrawl: "Последний розничный сбор:",
        never: "Никогда",
      },
      wholesale: {
        title: "Оптовое покрытие",
        liveOffersLabel: "Препараты с активными предложениями",
        liveOffersHelp: "{{rate}}% каталога имеет активные оптовые предложения",
        activeWholesalers: "Активные оптовики",
        offersWithExpiry: "Предложения со сроком годности",
        expiringWithin90: "Истекает в течение 90 дней",
        soon: "Скоро",
        lastCrawl: "Оптовые предложения последний сбор:",
        latestOfferIssue: "Последняя дата предложения:",
        latestPriceListDate: "Последняя дата прайс-листа:",
      },
      activity: {
        title: "Активность за 30 дней",
        description: "Обновления поставщиков, активные оптовики и объёмы предложений за последние 30 дней",
        emptyDescription: "Нет данных об активности за последние 30 дней.",
        supplierUpdates: "Обновления поставщиков",
        activeWholesalers: "Активные оптовики",
        wholesaleOffers: "Оптовые предложения",
        promotionalOffers: "Акционные предложения",
      },
      clickhouse: {
        title: "История аналитики (ClickHouse)",
        statuses: {
          available: "Доступна",
          partial: "Частично",
          unavailable: "Недоступна",
        },
        unavailableMessage: "История аналитики временно недоступна — на живые рыночные данные выше это не влияет.",
        partialMessage: "Покрытие истории неполное. Некоторые диапазоны дат могут отсутствовать.",
        retailHistory: "История розничных цен",
        wholesaleHistory: "История оптовых предложений",
        noHistory: "Диапазоны истории недоступны.",
        records: "{{count}} записей",
        noData: "Нет данных",
      },
    },
  },
} as const;
